import React, { useEffect, useState, useCallback, useRef } from "react";
import {
  BrowserRouter as Router,
  useNavigate,
  useLocation,
} from "react-router-dom";
import { Chip } from "@mui/material";
import Slide from "@mui/material/Slide";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Autocomplete from "@material-ui/lab/Autocomplete";
import Tooltip from "@mui/material/Tooltip";
import dayjs from "dayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import CustomDateTimePicker from '../../components/CustomDateTimePicker';
import CustomerTimePicker from '../../components/CustomTimePicker'
import { AdapterDateFns } from "@mui/x-date-pickers/AdapterDateFns";
import { Card, Divider, Select } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import { HighlightOff, InfoRounded, Done } from "@material-ui/icons";

import {
  Typography,
  Box,
  TextField,
  InputAdornment,
  Button,
  IconButton,
  Grid,
  OutlinedInput,
  Checkbox,
  ListItemText,
} from "@material-ui/core";
import clsx from 'clsx';
import CancelIcon from "@mui/icons-material/Cancel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import StopIcon from "@material-ui/icons/Stop";
import CloseIcon from "@material-ui/icons/Close";
import PaymentIcon from "@material-ui/icons/Payment";
import PhoneIcon from "@material-ui/icons/Phone";
import axios from "axios";
import {
  usePlacesWidget,
} from "react-google-autocomplete";
import { getUserId } from "../../Utils/Common";
import moment from "moment";
import MaterialAuto from "./MaterialAuto";
import MaterialAuto1 from "./MaterialAuto1";
import Geocode from "react-geocode";
import { Skeleton } from "@material-ui/lab";
import { useCompanyTheme } from '../../context/CompanyContext';
import { backendUrl, anonKey, adminBackend } from '../../config';
import { bookingEnabled } from '../../config';
import { countries } from '../../Utils/countries';
import { getDriverByModel, TaxiModelArray } from '../../Utils/vehicles';
import { useStyles } from '../../styles/booking-styles';
import { VehicleDisplay } from './vehicle-display';

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});
const API_KEY = process.env.REACT_APP_GEO_API_KEY;
const { BACKEND_URL } = backendUrl;
const { ANON_KEY } = anonKey;
const { ADMIN_BACKEND_URL } = adminBackend;


const BookButton = ({
  defaultPassengerId,
  selectedModel,
  driverDetails,
  dateValue,
  pickUp,
  drop,
  setsearchingDriver,
  setshowErrorMessage,
  setTripID,
  bookType,
  setBookType,
  transferStatus,
  setTransferStatus,
  fullDayStatus,
  setFullDayStatus,
  halfDayStatus,
  setHalfDayStatus,
  subscriptionStatus,
  setSubscriptionStatus,
  hourlyStatus,
  setHourlyStatus,
  setApproxTripFare,
  fareDetails,
  activeIndex,
  // setRoundTripStatus,
  // roundTripStatus,
  guest,
  approxTripFare,
  error,
  setError,
  distance,
  duration,
  startDate,
  endDate,
  time,
  setStartDate,
  setEndDate,
  setTime,
  setPickup,
  setDrop,
  planBaseFare,
  selectedDays,
  selectedHourlyTime,
  subscriptionTripFare,
  twoWayPickupTime,
  dayTimeState,
  waypoints,
  pickUp1,
  drop1,
  twoWaypoints,
  twoWayBaseFare,
  twoWayTripFare,
  selectedHourlyBookingTime,
  recurringBookingEnable,
  fareDetails1,
  companyId,
  companyTheme,
  modelHourlyFare,
  duration2,
  distance2,
  isValidPlan,
  oneWayRoutePolyline,
  twoWayRoutePolyline,
  errMsg,
  dropErrMsg,
  setPickupErrMsg
}) => {

  // console.log("companyTheme", companyTheme);


  const classes = useStyles({ companyTheme });


  const [paymentValue, setPaymentValue] = useState(1);

  const [open, setOpen] = useState(false);

  const [loader1, setLoader1] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [openOtp, setOpenOtp] = React.useState(false);
  const [countDown, setCountDown] = useState(null);
  const [openAdd3, setOpenAdd3] = React.useState(false);

  const [openAdd4, setOpenAdd4] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState("Something went wrong");
  const [val, setVal] = useState("");
  const [newUser, setNewUser] = useState(null);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  var subscriptionDetails = sessionStorage.getItem("subscriptionInfo");
  var subscriptionDetailsNew = JSON.parse(subscriptionDetails);
  var passengerId = JSON.parse(sessionStorage?.getItem('passengerId'));

  var otp = sessionStorage.getItem("otp");
  const [openAdd3Success, setOpenAdd3Success] = React.useState(false);

  const handleChangeType = (event) => {
    let model = fareDetails[activeIndex];
    // console.log(event.target.value);
    let bookType1 = event;
    // console.log(this);
    // console.log("bookType1", bookType1);

    if (bookType1 === "FullDay") {
      setBookType(1);
      if (model) {
        setApproxTripFare(model.full_day);
      }

      setHalfDayStatus(false);
      setTransferStatus(false);
      setFullDayStatus(true);
      setSubscriptionStatus(false);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "HalfDay") {
      setBookType(2);
      if (model) {
        setApproxTripFare(model.half_day);
      }

      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(true);
      setSubscriptionStatus(false);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "Transfer") {
      setBookType(0);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(true);
      setHalfDayStatus(false);
      setSubscriptionStatus(false);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "Subscription") {
      setBookType(3);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(false);
      setSubscriptionStatus(true);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    }
    else if (bookType1 === "Hourly") {
      setBookType(4);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(false);
      setSubscriptionStatus(false);
      setHourlyStatus(true);
      // setRoundTripStatus(false);
    }
  };

  useEffect(() => { }, []);

  Geocode.setApiKey(API_KEY);

  // set response language. Defaults to english.
  Geocode.setLanguage("en");

  // set response region. Its optional.
  // A Geocoding request with region=es (Spain) will return the Spanish city.
  Geocode.setRegion("ae");

  // Enable or disable logs. Its optional.
  Geocode.enableDebug();

  function getPassengerUpdate(trip_id) {
    //   // console.log("Helllllooooo", pickupLatLng.lat());

    setsearchingDriver(true);
    const postData = {
      passenger_tripid: trip_id,
      request_type: "1",
      drop_lat: 0,
      drop_long: 0,
      cancel_type: "0",
      passenger_id: "330",
    };
    axios
      .post(
        "https://fride.limor.us/passengerapi111/index/?encode=regina.taximobility.c" +
        "om-1636796261&type=getdriver_update&lang=en",
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "authkey ${authkey}",
          },
        }
      )
      .then((Response) => {
        if (Response.data.status == 1) {
          let fareDetails = Response.data.fare_details;
          // setTripInProgress(true);
          setTripID(trip_id);
          setsearchingDriver(false);
          //setshowErrorMessage("")

          // alert(Response.data.message);
          // setshowErrorMessage(Response.data.message)
        } else {
          //   setSearchingCar(false);
          // alert(Response.data.message);
          setsearchingDriver(false);
          setshowErrorMessage(Response.data.message);
        }
      })
      .catch((error) => {
        // console.log("error Comes:", error);
      });
  }

  const ResendOtp = () => {
    let obj;

    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    if (bookType === 3) {
      obj = {
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        subscription: 1, // Only included if bookType is 3
        email: a.email
      };
    } else {
      obj = {
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        email: a.email
      };
    }


    axios
      .post(
        `${BACKEND_URL}/passengerVerifyPhoneWeb?fromWebBooker=1`,
        obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        }

      )
      .then((Response) => {
        if (Response.data.status === 1) {
          setCountDown(30);

          setNewUser(Response.data.newUser);
          const obj2 = {
            passengerId: Response?.data?.responsData?._id,
          };

          sessionStorage.setItem("passengerId", JSON.stringify(obj2));

        } else if (Response.data.status === -1) {
          setCountDown(null);
          setAlertMsg(Response.data.message);
          setOpenAdd4(true);
        } else {
          setCountDown(null);
          setAlertMsg("Something went wrong");
          setOpenAdd3(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeValidate = (e) => {
    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setVal(e.target.value);
    }
  };

  const handleAddClose3 = () => {
    setOpenAdd3(false);
  };

  const handleAddClose4 = () => {
    setOpenAdd4(false);
  };

  const handleAddClose31 = () => {
    setOpenAdd3(false);
    // setOpenOtp(false);
  };

  const handleAddClose41 = () => {
    setOpenAdd4(false);
  };

  const handleClickOpenOtp = () => {
    setOpenOtp(true);
  };

  const handleCloseOtp = () => {
    setOpenOtp(false);
  };


  // console.log("openOtp", openOtp);


  function BookTaxi(address) {
    const items = JSON.parse(sessionStorage.getItem("newUser"));


    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    setLoader2(true);

    // setsearchingDriver(true);

    if (bookType === 3) {
      const formattedStartDate = moment(startDate, "YYYY-MM-DD HH:mm:ss")
        .startOf("day") // Sets time to 00:00:00
        .format("YYYY-MM-DD HH:mm:ss");

      const formattedEndDate = moment(endDate, "YYYY-MM-DD HH:mm:ss")
        .endOf("day") // Sets time to 23:59:59
        .format("YYYY-MM-DD HH:mm:ss");



      // console.log("planBaseFare", planBaseFare);

      const formattedPickupTime = moment(time, ["h:mm A"]).format("HH:mm:ss");
      const formattedTwoWayPickupTime = moment(twoWayPickupTime, [
        "h:mm A",
      ]).format("HH:mm:ss");

      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
      };

      const oneWayPickupTimeSlot = [];
      const twoWayPickupTimeSlot = [];

      const storedData = sessionStorage.getItem("dayTimeState");

      const dayTime = JSON.parse(storedData);

      Object.entries(dayTime).forEach(([day, times]) => {
        if (times.pickup) {
          oneWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.pickup}:00`,
          });
        }
        if (times.drop) {
          twoWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.drop}:00`,
          });
        }
      });

      let dropLocationInfo;

      if (waypoints.length !== 0) {
        dropLocationInfo = {
          address: [...waypoints.map((w) => w.address), drop.address],
          latitude: [
            ...waypoints.map((w) => w.coords.lat()),
            drop.coords.lat(),
          ],
          longitude: [
            ...waypoints.map((w) => w.coords.lng()),
            drop.coords.lng(),
          ],
        };
      } else {
        dropLocationInfo = {
          address: drop.address,
          latitude: drop.coords.lat(),
          longitude: drop.coords.lng(),
        };
      }

      let twoWayDropLocationInfo;

      if (twoWaypoints.length !== 0) {
        twoWayDropLocationInfo = {
          address: [...twoWaypoints.map((w) => w.address), drop1.address],
          latitude: [
            ...twoWaypoints.map((w) => w.coords.lat()),
            drop1.coords.lat(),
          ],
          longitude: [
            ...twoWaypoints.map((w) => w.coords.lng()),
            drop1.coords.lng(),
          ],
        };
      } else {
        twoWayDropLocationInfo = {
          address: drop1.address,
          latitude: drop1.coords.lat(),
          longitude: drop1.coords.lng(),
        };
      }

      const postData = {
        _id: defaultPassengerId,
        newUser: newUser,
        motorModelId: selectedModel._id,
        otp: otp,
        subscriptionPlanInfo: subscriptionDetailsNew,
        pickupTime: formattedPickupTime,
        // customerName: a.firstName + " " +a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        phoneNumber: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        pickupLocationInfo: {
          address: pickUp.address,
          latitude: pickUp.coords.lat(),
          longitude: pickUp.coords.lng(),
        },
        dropLocationInfo,
        approxDistance: distance,
        approxDuration: duration,
        type: subscriptionDetailsNew?.type,
        tripType: subscriptionDetailsNew?.tripType,
        farePerTrip: subscriptionTripFare,
        totalFare: planBaseFare,
        startDateTime: formattedStartDate,
        endDateTime: formattedEndDate,
        oneWayRoutePolyline,
        daySlot: selectedDays,
        hours: selectedHourlyTime,
        recurringBookingEnable: recurringBookingEnable,
        ...(subscriptionDetailsNew?.tripType === 2 && {
          twoWayRoutePolyline,
          twoWayPickupTime: formattedTwoWayPickupTime,
          twoWayDropLocationInfo,
          twoWayPickupLocationInfo: {
            address: pickUp1.address,
            latitude: pickUp1.coords.lat(),
            longitude: pickUp1.coords.lng(),
          },
          twoWayfarePerTrip: twoWayTripFare,
          twoWaytotalFare: twoWayBaseFare,
          twoWayApproxDistance: distance2,
          twoWayApproxDuration: duration2
        }),

        oneWayPickupTimeSlot,
        twoWayPickupTimeSlot,
      };


      if (!errMsg && !dropErrMsg) {
        axios
          .post(
            `${BACKEND_URL}/createSubscriptionEnquiry?fromWebBooker=1`,
            postData,
            {
              headers: { Authorization: `Bearer ${ANON_KEY}` }
            }
          )
          .then((Response) => {
            if (Response.data.status >= 1) {
              setOpenOtp(false);
              setAlertMsg(Response.data.message);
              setshowErrorMessage(Response.data);
              setLoader2(false);
              setOpenAdd3Success(true);
              setLoader1(false);

              /* sessionStorage.setItem(
                "passengerInfo",
                JSON.stringify(Response?.data?.detail?.passengerInfo)
              );

              const obj2 = {
                passengerId: Response?.data?.detail?.passengerInfo?.id,
              };
              sessionStorage.setItem("passengerId", JSON.stringify(obj2)); */
            }
            else {
              setBookType(3);

              if (Response.data.isVerified) {
                setOpenOtp(false);
              } else {
                setOpenOtp(true);
              }
              setAlertMsg(Response.data.message);
              setLoader2(false);
              setLoader1(false);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {


      const rawEstimatedFare = fareDetails1?.split_up?.flat()?.find(
        (item) => item.key === "estimatedFare"
      )?.value;

      let estimatedFare = '';

      if (rawEstimatedFare) {
        const match = rawEstimatedFare.match(/^([A-Z]+)\s?([\d.]+)$/);
        if (match) {
          const fareCurrency = match[1];
          const fareAmount = match[2];
          estimatedFare = fareAmount;
        }
      }


      // console.log("selectedHourlyBookingTime", selectedHourlyBookingTime);


      const postData = {
        phone: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        latitude: pickUp.coords.lat().toString(),
        longitude: pickUp.coords.lng().toString(),
        pickupplace: address,
        dropplace: drop.address,
        drop_latitude: drop.coords.lat().toString(),
        drop_longitude: drop.coords.lng().toString(),
        pickup_time: dateValue
          ? dayjs(dateValue).format("YYYY-MM-DD hh:mm:ss A")
          : moment().format("YYYY-MM-DD hh:mm:ss A"),
        motor_model: selectedModel._id,
        cityname: "",
        distance_away: 0,
        sub_logid: "",
        friend_id2: "0",
        friend_percentage2: "0",
        friend_id3: "0",
        friend_percentage3: "0",
        friend_id4: "0",
        friend_percentage4: "0",
        friend_id1: getUserId(),
        friend_percentage1: "100",
        passenger_payment_option: 1,
        payment_mode: "1",
        approx_distance: distance,
        approx_duration: duration,
        // passenger_id: '56',
        request_type: "1",
        promo_code: "",
        now_after: 1,
        notes: "",
        passenger_app_version: "1",
        pickup_notes: "",
        drop_notes: "",
        drop_makani: "",
        pickup_makani: "",
        is_guest_booking: "0",
        // name: a.firstName + " " + a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        guestInfo: {
          countryCode: `+${a.countryCode}`,
          email: a.email,
          mobileNumber: a.mobileNumber,
          name: a.firstName + " " + a.lastName,
        },
        ...(bookType === 4 && {
          requested_trip_hour: selectedHourlyBookingTime,
          hourly_fare: modelHourlyFare,
          approxTripFare: selectedHourlyBookingTime * modelHourlyFare,
        }),
        ...(bookType !== 4 && {
          // approx_fare: estimatedFare,
          approxTripFare: estimatedFare,
        }),
        // approxTripFare: drop.address !== "" ? approxTripFare : 0,
        passenger_cid: companyId,
        companyId: companyId,
        otp: val,
        newUser: items.newUser,
      };


      // console.log("selectedModel", selectedModel);
      // console.log("postData 1", postData);

      axios
        .post(
          `${BACKEND_URL}/saveBooking?fromWebBooker=1`,
          postData,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}` }
          }
        )
        .then((Response) => {
          if (Response.data.status >= 1) {
            setLoader2(false);

            if (dateValue) {
              setshowErrorMessage(Response.data);

              const obj2 = {
                passengerId: Response?.data?.detail?.passengerInfo?.id,
              };

              sessionStorage.setItem(
                "passengerInfo",
                JSON.stringify(Response?.data?.detail?.passengerInfo)
              );

              sessionStorage.setItem("passengerId", JSON.stringify(obj2));
            } else {
              getPassengerUpdate(Response.data.detail.passenger_tripid);
            }
          }
          else {
            setAlertMsg(Response.data.message);
            setOpenAdd3(true);
            setLoader2(false);
            setshowErrorMessage(Response.data);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const location = useLocation();

  const params = new URLSearchParams(location.search);
  let pickupCheck = params.get("pickupplace");
  let dropCheck = params.get("dropplace");

  return (
    <Box style={{ flexGrow: 1, marginTop: "8px" }}>
      <Grid container spacing={0} flexDirection="row" alignItems="center">
        <Grid item xs={4} className={classes.formContent}>
          <Box style={{ width: "160px" }}>
            <Typography
              style={{ fontSize: "14px", fontWeight: "400", }}
              variaint="subtitle2"
            >
              Type:
            </Typography>
          </Box>
        </Grid>
        <Dialog
          open={openAdd3}
          TransitionComponent={Transition}
          keepMounted
          style={{
            position: "absolute",
            zIndex: 2000,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          maxWidth="xl"
          onClose={handleAddClose3}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent style={{ width: "400px" }}>
            <DialogContentText id="alert-dialog-slide-description">
              <Grid container spacing={3}>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src="/static/images/reject.png"
                    alt="Success"
                    width="100"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h3 style={{ color: "red" }}>{alertMsg}</h3>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleAddClose31}
              variant="contained"
              color="white"
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                color: "white",
                borderRadius: "4px",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openAdd4}
          TransitionComponent={Transition}
          keepMounted
          style={{
            position: "absolute",
            zIndex: 2000,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          maxWidth="xl"
          onClose={handleAddClose4}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent style={{ width: "400px" }}>
            <DialogContentText id="alert-dialog-slide-description">
              <Grid container spacing={3}>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src="/static/images/reject.png"
                    alt="Success"
                    width="100"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h3 style={{ color: "red" }}>{alertMsg}</h3>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleAddClose41}
              variant="contained"
              color="white"
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                color: "white",
                borderRadius: "4px",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openOtp}
          // onClose={handleCloseOtp}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ boxShadow: "1px 1px 1px 1px" }}
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ paddingTop: "6px", paddingRight: "14px" }}
          >
            <Grid
              container
              spacing={3}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Grid item>{"Please, Enter OTP!"}</Grid>
              <Grid item>
                <CloseIcon
                  onClick={handleCloseOtp}
                  style={{
                    color: "red",
                    border: "1px solid red",
                    cursor: "pointer",
                  }}
                />
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <>
              <TextField
                id="outlined-basic"
                label="OTP"
                inputProps={{ maxLength: 4 }}
                style={{ marginTop: "25px" }}
                value={val}
                onChange={handleChangeValidate}
                fullWidth
                variant="outlined"
              />
              <a
                style={{
                  fontSize: "13px",
                  marginTop: "5px",
                  color:
                    countDown !== null && countDown !== 0 ? "#9d9d9d" : "blue",
                  pointerEvents:
                    countDown !== null && countDown !== 0 ? "none" : "",
                  cursor:
                    countDown !== null && countDown !== 0 ? "" : "pointer",
                }}
                onClick={() => ResendOtp(pickUp.address)}
                disabled={countDown !== null && countDown !== 0 ? true : false}
              >
                Resend OTP{" "}
                {countDown !== null && countDown !== 0 ? `(${countDown})` : ""}
              </a>
            </>
          </DialogContent>
          <DialogActions>
            <>
              <Button
                onClick={() => BookTaxi(pickUp.address)}
                style={{
                  backgroundColor: companyTheme?.primaryColorCode,
                  borderRadius: "4px",
                }}
                disabled={val.length === 4 ? false : true}
                variant="contained"              >
                {loader2 ? (
                  <CircularProgress style={{ width: "30px", height: "30px", color: 'white' }} />
                ) : (
                  "Verify"
                )}
              </Button>
            </>
          </DialogActions>
        </Dialog>
        <Grid
          item
          xs={8}
          style={{ marginTop: "16px" }}
          className={classes.formContent}
        >
          <Box>
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                justifyContent: "start",
              }}
            >
              <div onChange={(e) => handleChangeType(e.target.value)}>
                <div className="sound-signal">
                  <input
                    type="radio"
                    value="Transfer"
                    name="transfer"
                    id="soundsignal3"
                    checked={transferStatus}
                  />
                  <label for="soundsignal3" style={{ marginRight: "12px" }}>
                    Transfer
                  </label>


                  {/* {BOOKING_ENABLED_COMPANIES?.map(Number).includes(Number(companyId)) ? ( */}
                  <>
                    <input
                      type="radio"
                      value="Subscription"
                      name="bookingType"
                      id="soundsignal6"
                      checked={subscriptionStatus}
                    />
                    <label htmlFor="soundsignal6" style={{ marginRight: "12px" }}>
                      Subscription
                    </label>


                  </>

                </div>
              </div>
            </Box>
          </Box>
        </Grid>
      </Grid>
      <Box></Box>
    </Box>
  );
};

const BookButtonNew = ({
  defaultPassengerId,
  selectedModel,
  driverDetails,
  dateValue,
  selectedPlan,
  pickUp,
  drop,
  setsearchingDriver,
  setshowErrorMessage,
  setTripID,
  bookType,
  setBookType,
  transferStatus,
  setTransferStatus,
  fullDayStatus,
  setFullDayStatus,
  halfDayStatus,
  setHalfDayStatus,
  subscriptionStatus,
  setSubscriptionStatus,
  hourlyStatus, setHourlyStatus,
  setApproxTripFare,
  fareDetails,
  activeIndex,
  guest,
  approxTripFare,
  error,
  setError,
  startDate,
  endDate,
  time,
  setStartDate,
  setEndDate,
  setTime,
  setPickup,
  setDrop,
  planBaseFare,
  selectedDays,
  selectedHourlyTime,
  subscriptionTripFare,
  twoWayPickupTime,
  distance,
  duration,
  waypoints,
  pickUp1,
  drop1,
  twoWaypoints,
  twoWayBaseFare,
  twoWayTripFare,
  selectedHourlyBookingTime,
  recurringBookingEnable,
  fareDetails1,
  companyId,
  companyTheme,
  modelHourlyFare,
  duration2,
  distance2,
  totalDaysCount,
  isValidPlan,
  oneWayRoutePolyline,
  twoWayRoutePolyline,
  errMsg,
  dropErrMsg,
  setPickupErrMsg
}) => {

  const [paymentValue, setPaymentValue] = useState(1);

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const [open, setOpen] = useState(false);

  var subscriptionDetails = sessionStorage.getItem("subscriptionInfo");
  var subscriptionDetailsNew = JSON.parse(subscriptionDetails);
  var passengerId = JSON.parse(sessionStorage?.getItem('passengerId'));
  var otp = sessionStorage.getItem("otp");
  const [loader1, setLoader1] = useState(false);

  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);
  const [openOtp, setOpenOtp] = React.useState(false);
  const [countDown, setCountDown] = useState(null);
  const [openAdd3, setOpenAdd3] = React.useState(false);
  const [openAdd3Success, setOpenAdd3Success] = React.useState(false);
  const [openAdd4, setOpenAdd4] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState("Something went wrong");
  const [val, setVal] = useState("");
  const [emailExistMessage, setEmailExistMessage] = useState("");
  const [newUser, setNewUser] = useState(null);

  const handleChangeType = (event) => {
    let model = fareDetails[activeIndex];
    // console.log(event.target.value);
    let bookType1 = event;
    // console.log(this);
    // console.log(bookType1);

    if (bookType1 === "FullDay") {
      setBookType(1);
      if (model) {
        setApproxTripFare(model.full_day);
      }

      setHalfDayStatus(false);
      setTransferStatus(false);
      setFullDayStatus(true);
      setSubscriptionStatus(false);
      setHalfDayStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "HalfDay") {
      setBookType(2);
      if (model) {
        setApproxTripFare(model.half_day);
      }

      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(true);
      setSubscriptionStatus(false);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "Transfer") {
      setBookType(0);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(true);
      setHalfDayStatus(false);
      setSubscriptionStatus(false);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    } else if (bookType1 === "Subscription") {
      setBookType(0);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(false);
      setSubscriptionStatus(true);
      setHourlyStatus(false);
      // setRoundTripStatus(false);
    }
    else if (bookType1 === "Hourly") {
      setBookType(0);
      if (model) {
        setApproxTripFare(model.fare);
      }
      setFullDayStatus(false);
      setTransferStatus(false);
      setHalfDayStatus(false);
      setSubscriptionStatus(false);
      setHourlyStatus(true);
      // setRoundTripStatus(false);
    }
  };


  const handlePaymentChange = (event) => {
    setPaymentValue(event.target.value);
    // console.log(paymentValue);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const handleOpen = () => {
    setOpen(true);
  };

  useEffect(() => { }, []);

  Geocode.setApiKey(API_KEY);

  // set response language. Defaults to english.
  Geocode.setLanguage("en");

  // set response region. Its optional.
  // A Geocoding request with region=es (Spain) will return the Spanish city.
  Geocode.setRegion("ae");

  // Enable or disable logs. Its optional.
  Geocode.enableDebug();

  function getPassengerUpdate(trip_id) {
    //   // console.log("Helllllooooo", pickupLatLng.lat());

    setsearchingDriver(true);
    const postData = {
      passenger_tripid: trip_id,
      request_type: "1",
      drop_lat: 0,
      drop_long: 0,
      cancel_type: "0",
      passenger_id: "330",
    };
    axios
      .post(
        "https://fride.limor.us/passengerapi111/index/?encode=regina.taximobility.c" +
        "om-1636796261&type=getdriver_update&lang=en",
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "authkey ${authkey}",
          },
        }
      )
      .then((Response) => {
        // console.log("savebook statusssssss--->", Response.data.status);
        //{"message":"Your booking is confirmed.","trip_id":901966,"is_first_trip":"","event_ride_count":"0","status":1,"user_key":"7e1b314f553e5981e9f11507ee08db2933befc35403cc0c0f715d7c48bde6764_61b73888b374ae141f7f51d5"}
        if (Response.data.status == 1) {
          let fareDetails = Response.data.fare_details;
          // setTripInProgress(true);
          setTripID(trip_id);
          setsearchingDriver(false);
          //setshowErrorMessage("")

          // alert(Response.data.message);
          // setshowErrorMessage(Response.data.message)
        } else {
          //   setSearchingCar(false);
          // alert(Response.data.message);
          setsearchingDriver(false);
          setshowErrorMessage(Response.data.message);
        }
      })
      .catch((error) => {
        console.log("error Comes:", error);
      });
  }

  function validateScheduleTimes(schedule) {
    for (const [day, times] of Object.entries(schedule)) {
      const [ph, pm] = times?.pickup && times?.pickup?.split(":").map(Number);
      const [dh, dm] = times?.drop && times?.drop?.split(":").map(Number);

      const pickupMinutes = ph * 60 + pm;
      const dropMinutes = dh * 60 + dm;

      // if (pickupMinutes >= dropMinutes) {
      //   return {
      //     isValid: false,
      //     message: `On ${day}, the pickup time (${times?.pickup}) must be earlier than the drop time (${times?.drop}).`
      //   };
      // }

      if (pickupMinutes >= dropMinutes) {
        const pickupFormatted = dayjs(times?.pickup, 'HH:mm').format('hh:mm A');
        const dropFormatted = dayjs(times?.drop, 'HH:mm').format('hh:mm A');

        return {
          isValid: false,
          message: `On ${day}, the One Way Pickup time (${pickupFormatted}) must be earlier than the Two Way Pickup time (${dropFormatted}).`
        };
      }


    }

    return {
      isValid: true,
      message: "All pickup times are valid."
    };
  }



  //  console.log("selectedHourlyBookingTime", selectedHourlyBookingTime)


  // function validateScheduleTimes(schedule) {
  //   if (!schedule || typeof schedule !== "object") {
  //     return {
  //       isValid: false,
  //       message: "Schedule must be an object of day → { pickup, drop } entries."
  //     };
  //   }

  //   for (const [day, times] of Object.entries(schedule)) {
  //     // Make sure both pickup and drop exist and look like “HH:MM”
  //     console.log("testing times", times, day)
  //     if (
  //       !times ||
  //       typeof times.pickup !== "string" ||
  //       typeof times.drop !== "string" ||
  //       !times.pickup.includes(":") ||
  //       !times.drop.includes(":")
  //     ) {
  //       return {
  //         isValid: false,
  //         message: `On ${day}, expected both pickup and drop times in "HH:MM" format.`
  //       };
  //     }

  //     const [ph, pm] = times.pickup.split(":").map(Number);
  //     const [dh, dm] = times.drop.split(":").map(Number);

  //     const pickupMinutes = ph * 60 + pm;
  //     const dropMinutes = dh * 60 + dm;

  //     if (Number.isNaN(pickupMinutes) || Number.isNaN(dropMinutes)) {
  //       return {
  //         isValid: false,
  //         message: `On ${day}, could not parse pickup (“${times.pickup}”) or drop (“${times.drop}”) time.`
  //       };
  //     }

  //     if (pickupMinutes >= dropMinutes) {
  //       return {
  //         isValid: false,
  //         message: `On ${day}, pickup time (${times.pickup}) must be earlier than drop time (${times.drop}).`
  //       };
  //     }
  //   }

  //   return {
  //     isValid: true,
  //     message: "All pickup and drop times are valid."
  //   };
  // }

  const handleOtpCheck = () => {


    setLoader3(true);
    // handleClickOpenOtp();

    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    setLoader1(true);


    if (
      a.firstName === "" ||
      a.email === "" ||
      a.mobileNumber === "" ||
      pickUp?.address === "" ||
      drop?.address === ""
    ) {
      setAlertMsg("All Fields Are Required");
      setLoader1(false);
      setOpenAdd3(true);
      return;
    }

    const daySlot = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const dayTimeState = JSON.parse(sessionStorage.getItem("dayTimeState"));

    const isTimeSlotValid = () => {

      for (const dayIndex of selectedDays) {
        const dayName = daySlot[dayIndex];

        if (!dayName) {
          // console.warn("Invalid day index:", dayIndex);
          return false;
        }

        if (dayTimeState && Object.keys(dayTimeState).length !== 0) {
          const dayState = dayTimeState[dayName];
          if (!dayState?.pickup) {
            return false;
          }

          if (selectedPlan?.tripType === 2 && !dayState?.drop) {
            return false;
          }
        } else {
          return false;
        }
      }
      return true;
    };


    const validateDayTimeState = (dayTimeState, startDate, endDate, selectedDays, daySlot) => {
      if (!dayTimeState || Object.keys(dayTimeState).length === 0) {
        return { isValid: false, message: "Day slots are required" };
      }


      const validDays = [];
      let current = new Date(startDate);
      const end = new Date(endDate);

      while (current <= end) {
        validDays.push(
          current.toLocaleDateString("en-US", { weekday: "long" }) // e.g., "Tuesday"
        );
        current.setDate(current.getDate() + 1);
      }

      const selectedDayNames = selectedDays.map(i => daySlot[i]);

      for (const dayName of selectedDayNames) {
        if (!validDays.includes(dayName)) {
          return { isValid: false, message: `${dayName} is outside your selected date range` };
        }

        // Also check pickup/drop times
        const times = dayTimeState[dayName];
        if (!times?.pickup || (times.pickup === "00:00" && times.drop === "00:00")) {
          return {
            isValid: false,
            //  message: `${dayName} has invalid pickup/drop times. Drop Time must be Greater than ppickup Time`
            message: 'TwoWay Time must be Greater than OneWay Pickup Time'
          };
        }
      }

      return { isValid: true, message: "" };
    };



    if (bookType === 3) {
      if (!isTimeSlotValid()) {
        // setAlertMsg("All Fields Are Required");
        setPickupErrMsg("Please select Valid Pickup and Drop");
        setLoader1(false);
        // setOpenAdd3(true);
        return;
      } else {
        setPickupErrMsg(null);
      }


      if (totalDaysCount > 22) {
        // alert("Please select 22 days or fewer.");
        setLoader1(false);

        setPickupErrMsg("Please select 22 days or fewer");
        return;
      }



      const dayValidation = validateDayTimeState(dayTimeState,
        startDate,
        endDate,
        selectedDays,
        daySlot);

      if (!dayValidation.isValid) {
        setPickupErrMsg(dayValidation.message);
        setLoader1(false);
        return;
      }

      if (selectedPlan?.tripType === 2 && dayTimeState && !validateScheduleTimes(dayTimeState).isValid) {
        // setAlertMsg(validateScheduleTimes(dayTimeState).message);
        // setLoader1(false);
        // setOpenAdd3(true);
        // alert(validateScheduleTimes(dayTimeState).message);
        setPickupErrMsg(validateScheduleTimes(dayTimeState).message);
        setLoader1(false);
        return;
      } else {
        setPickupErrMsg(null);
      }



      if (
        !selectedDays ||
        !selectedPlan ||
        selectedDays.length === 0 ||
        time === "" ||
        planBaseFare === 0 ||
        (selectedPlan.tripType === 2 && twoWayPickupTime === "") ||
        (selectedPlan.tripType === 2 && pickUp1?.address === "") ||
        (selectedPlan.tripType === 2 && drop1?.address === "") ||
        (selectedPlan.type === 3 && selectedHourlyTime === "")
      ) {
        setAlertMsg("All Fields Are Required");
        setLoader1(false);
        setOpenAdd3(true);
        return;
      }
    }

    if (bookType === 4) {
      if (selectedHourlyBookingTime === 0 || selectedHourlyBookingTime < 0 || selectedModel.hourly_fare < 0) {
        setAlertMsg("All Fields Are Required");
        setLoader1(false);
        setOpenAdd3(true);
        return;
      }

    }

    let obj = {
      countryCode: `+${a.countryCode}`,
      phone: a.mobileNumber,
      companyId: companyId,
      type: 1,
      subscription: bookType === 3 ? 1 : 0,
      email: a.email
    };




    axios
      .post(
        `${BACKEND_URL}/passengerVerifyPhoneWeb?fromWebBooker=1`,
        obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        }

      )
      .then((Response) => {
        if (Response.data.status === 1) {
          setCountDown(30);
          setLoader1(false);
          setLoader3(false);
          setNewUser(Response.data.newUser);
          setEmailExistMessage(Response?.data?.emailExistMessage)
          sessionStorage.setItem(
            "newUser",
            JSON.stringify({ newUser: Response.data.newUser })
          );

          const obj2 = {
            passengerId: Response?.data?.responsData?._id,
          };

          sessionStorage.setItem("passengerId", JSON.stringify(obj2));

          // sessionStorage.setItem("id", Response.data.responsData._id);
          handleClickOpenOtp();
        } else if (Response.data.status === -1) {
          setLoader3(false);
          handleCloseOtp();
          setLoader1(false);
          setCountDown(null);
          setAlertMsg(Response.data.message);
          setOpenAdd4(true);
        } else {
          handleCloseOtp();
          setCountDown(null);
          setLoader1(false);
          setLoader3(false);
          setAlertMsg("Something went wrong");
          setOpenAdd3Success(true);
        }
      })
      .catch((error) => {
        setCountDown(null);
        console.log(error);
      });
  };

  useEffect(() => {
    if (countDown !== null && countDown !== 0) {
      const interval = setInterval(() => {
        setCountDown(countDown - 1);
      }, 1000);

      return () => clearInterval(interval);
    }
  }, [countDown]);


  // const dayTimeState = JSON.parse(sessionStorage.getItem("dayTimeState"));

  // useEffect(() => {

  //   if(dayTimeState && validateScheduleTimes(dayTimeState).isValid){
  //     setPickupErrMsg(null);
  //   } 
  // }, [dayTimeState]);



  const ResendOtp = () => {


    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    let obj;

    if (bookType === 3) {
      obj = {
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        subscription: 1,
        email: a.email
      };
    } else {
      obj = {
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        subscription: 0,
        email: a.email
      };
    }
    setLoader2(true);

    axios
      .post(
        `${BACKEND_URL}/passengerVerifyPhoneWeb?fromWebBooker=1`,
        obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        }

      )
      .then((Response) => {
        if (Response.data.status === 1) {
          setCountDown(30);
          setNewUser(Response.data.newUser);
          const obj2 = {
            passengerId: Response?.data?.responsData?._id,
          };

          sessionStorage.setItem("passengerId", JSON.stringify(obj2));

        } else if (Response.data.status === -1) {
          setCountDown(null);
          setAlertMsg(Response.data.message);
          setOpenAdd4(true);
          setOpenAdd3(true);
        } else {
          setCountDown(null);
          setAlertMsg("Something went wrong");
          setOpenAdd3(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const handleChangeValidate = (e) => {
    const regex = /^[0-9\b]+$/;
    sessionStorage.removeItem("otp");

    if (e.target.value === "" || regex.test(e.target.value)) {
      setVal(e.target.value);
    }

    sessionStorage.setItem("otp", e.target.value);
  };

  const handleAddClose3 = () => {
    setOpenAdd3(false);
  };

  const handleAddCloseSuccess = () => {
    setOpenAdd3Success(false);
  };

  const handleAddClose4 = () => {
    setOpenAdd4(false);
  };

  const handleAddClose31 = () => {
    // setOpenOtp(false);
    setOpenAdd3(false);
    setLoader1(false);

  };


  const handleAddClose41 = () => {
    setOpenAdd4(false);
  };

  const handleClickOpenOtp = () => {
    setOpenOtp(true);
    // setLoader2(true);
  };

  const handleCloseOtp = () => {
    setOpenOtp(false);
    setEmailExistMessage("");
  };


  function BookTaxi(address) {
    const items = JSON.parse(sessionStorage.getItem("newUser"));

    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    setLoader1(true);

    setLoader2(true);

    setVal("");

    if (
      a.firstName === "" ||
      a.email === "" ||
      a.mobileNumber === "" ||
      pickUp?.address === "" ||
      drop?.address === ""
    ) {
      setAlertMsg("All Fields Are Required");
      setLoader1(false);
      setOpenAdd3(true);
      return;
    }

    const daySlot = [
      "Sunday",
      "Monday",
      "Tuesday",
      "Wednesday",
      "Thursday",
      "Friday",
      "Saturday",
    ];

    const dayTimeState = JSON.parse(sessionStorage.getItem("dayTimeState"));

    const isTimeSlotValid = () => {

      for (const dayIndex of selectedDays) {
        const dayName = daySlot[dayIndex];

        if (!dayName) {
          // console.warn("Invalid day index:", dayIndex);
          return false;
        }

        if (dayTimeState && Object.keys(dayTimeState).length !== 0) {
          const dayState = dayTimeState[dayName];
          if (!dayState?.pickup) {
            return false;
          }

          if (selectedPlan?.tripType === 2 && !dayState?.drop) {
            return false;
          }
        } else {
          return false;
        }
      }
      return true;
    };


    const validateDayTimeState = (dayTimeState, startDate, endDate, selectedDays, daySlot) => {
      if (!dayTimeState || Object.keys(dayTimeState).length === 0) {
        return { isValid: false, message: "Day slots are required" };
      }


      const validDays = [];
      let current = new Date(startDate);
      const end = new Date(endDate);

      while (current <= end) {
        validDays.push(
          current.toLocaleDateString("en-US", { weekday: "long" }) // e.g., "Tuesday"
        );
        current.setDate(current.getDate() + 1);
      }

      const selectedDayNames = selectedDays.map(i => daySlot[i]);

      for (const dayName of selectedDayNames) {
        if (!validDays.includes(dayName)) {
          return { isValid: false, message: `${dayName} is outside your selected date range` };
        }

        // Also check pickup/drop times
        const times = dayTimeState[dayName];
        if (!times?.pickup || (times.pickup === "00:00" && times.drop === "00:00")) {
          return {
            isValid: false,
            //  message: `${dayName} has invalid pickup/drop times. Drop Time must be Greater than ppickup Time`
            message: 'TwoWay Time must be Greater than OneWay Pickup Time'
          };
        }
      }

      return { isValid: true, message: "" };
    };



    if (bookType === 3) {
      if (!isTimeSlotValid()) {
        // setAlertMsg("All Fields Are Required");
        setPickupErrMsg("Please select Valid Pickup and Drop");
        setLoader1(false);
        // setOpenAdd3(true);
        return;
      } else {
        setPickupErrMsg(null);
      }


      if (totalDaysCount > 22) {
        // alert("Please select 22 days or fewer.");
        setLoader1(false);

        setPickupErrMsg("Please select 22 days or fewer");
        return;
      }



      const dayValidation = validateDayTimeState(dayTimeState,
        startDate,
        endDate,
        selectedDays,
        daySlot);

      if (!dayValidation.isValid) {
        setPickupErrMsg(dayValidation.message);
        setLoader1(false);
        return;
      }

      if (selectedPlan?.tripType === 2 && dayTimeState && !validateScheduleTimes(dayTimeState).isValid) {
        // setAlertMsg(validateScheduleTimes(dayTimeState).message);
        // setLoader1(false);
        // setOpenAdd3(true);
        // alert(validateScheduleTimes(dayTimeState).message);
        setPickupErrMsg(validateScheduleTimes(dayTimeState).message);
        setLoader1(false);
        return;
      } else {
        setPickupErrMsg(null);
      }



      if (
        !selectedDays ||
        !selectedPlan ||
        selectedDays.length === 0 ||
        time === "" ||
        planBaseFare === 0 ||
        (selectedPlan.tripType === 2 && twoWayPickupTime === "") ||
        (selectedPlan.tripType === 2 && pickUp1?.address === "") ||
        (selectedPlan.tripType === 2 && drop1?.address === "") ||
        (selectedPlan.type === 3 && selectedHourlyTime === "")
      ) {
        setAlertMsg("All Fields Are Required");
        setLoader1(false);
        setOpenAdd3(true);
        return;
      }
    }

    if (bookType === 3) {

      const formattedStartDate = moment(startDate, "YYYY-MM-DD HH:mm:ss")
        .startOf("day")
        .format("YYYY-MM-DD HH:mm:ss");

      const formattedEndDate = moment(endDate, "YYYY-MM-DD HH:mm:ss")
        .endOf("day") // Sets time to 23:59:59
        .format("YYYY-MM-DD HH:mm:ss");

      const formattedPickupTime = moment(time, ["h:mm A"]).format("HH:mm:ss");
      const formattedTwoWayPickupTime = moment(twoWayPickupTime, [
        "h:mm A",
      ]).format("HH:mm:ss");

      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
      };

      const oneWayPickupTimeSlot = [];
      const twoWayPickupTimeSlot = [];

      const storedData = sessionStorage.getItem("dayTimeState");

      const dayTime = JSON.parse(storedData);

      Object.entries(dayTime).forEach(([day, times]) => {
        if (times.pickup) {
          oneWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.pickup}:00`,
          });
        }
        if (times.drop) {
          twoWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.drop}:00`,
          });
        }
      });

      let dropLocationInfo;

      if (waypoints.length !== 0) {
        dropLocationInfo = {
          address: [...waypoints.map((w) => w.address), drop.address],
          latitude: [
            ...waypoints.map((w) => w.coords.lat()),
            drop.coords.lat(),
          ],
          longitude: [
            ...waypoints.map((w) => w.coords.lng()),
            drop.coords.lng(),
          ],
        };
      } else {
        dropLocationInfo = {
          address: drop.address,
          latitude: drop.coords.lat(),
          longitude: drop.coords.lng(),
        };
      }

      let twoWayDropLocationInfo;

      if (twoWaypoints.length !== 0) {
        twoWayDropLocationInfo = {
          address: [...twoWaypoints.map((w) => w.address), drop1.address],
          latitude: [
            ...twoWaypoints.map((w) => w.coords.lat()),
            drop1.coords.lat(),
          ],
          longitude: [
            ...twoWaypoints.map((w) => w.coords.lng()),
            drop1.coords.lng(),
          ],
        };
      } else {
        twoWayDropLocationInfo = {
          address: drop1.address,
          latitude: drop1.coords.lat(),
          longitude: drop1.coords.lng(),
        };
      }

      const postData = {
        _id: defaultPassengerId,
        motorModelId: selectedModel._id,
        subscriptionPlanInfo: subscriptionDetailsNew,
        pickupTime: formattedPickupTime,
        // customerName: a.firstName + " " +a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        phoneNumber: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        pickupLocationInfo: {
          address: pickUp.address,
          latitude: pickUp.coords.lat(),
          longitude: pickUp.coords.lng(),
        },
        dropLocationInfo,
        approxDistance: distance,
        approxDuration: duration,
        type: subscriptionDetailsNew?.type,
        tripType: subscriptionDetailsNew?.tripType,
        farePerTrip: subscriptionTripFare,
        totalFare: planBaseFare,
        startDateTime: formattedStartDate,
        endDateTime: formattedEndDate,
        daySlot: selectedDays,
        hours: selectedHourlyTime,
        oneWayRoutePolyline,
        isRecurringBooking: recurringBookingEnable,
        ...(subscriptionDetailsNew?.tripType === 2 && {

          twoWayRoutePolyline,
          twoWayPickupTime: formattedTwoWayPickupTime,
          twoWayDropLocationInfo,
          twoWayPickupLocationInfo: {
            address: pickUp1.address,
            latitude: pickUp1.coords.lat(),
            longitude: pickUp1.coords.lng(),
          },
          twoWayfarePerTrip: twoWayTripFare,
          twoWaytotalFare: twoWayBaseFare,
          twoWayApproxDistance: distance2,
          twoWayApproxDuration: duration2
        }),

        oneWayPickupTimeSlot,
        twoWayPickupTimeSlot,
      };

      if (!errMsg && !dropErrMsg) {
        axios
          .post(
            `${BACKEND_URL}/createSubscriptionEnquiry?fromWebBooker=1`,
            postData,
            {
              headers: { Authorization: `Bearer ${ANON_KEY}` }
            }
          )
          .then((Response) => {
            if (Response.data.status >= 1) {
              setLoader1(false);
              setEmailExistMessage("");
              //  let fareDetails = Response.data.fare_details;
              setOpenOtp(false);
              setAlertMsg(Response.data.message);
              setshowErrorMessage(Response.data);
              setLoader2(false);
              setOpenAdd3(true);
              /* sessionStorage.setItem(
                "passengerInfo",
                JSON.stringify(Response?.data?.detail?.passengerInfo)
              );

              const obj2 = {
                passengerId: Response?.data?.detail?.passengerInfo?.id,
              };

              sessionStorage.setItem("passengerId", JSON.stringify(obj2)); */

            }
            else {
              setBookType(3);
              setshowErrorMessage(Response.data);

              if (Response.data.isVerified) {
                setOpenOtp(false);
              } else {
                setOpenOtp(true);
              }
              setAlertMsg(Response.data.message);

              setLoader2(false);
              setLoader1(false);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {


      // console.log("fareDetails1", fareDetails1)


      const rawEstimatedFare = fareDetails1?.split_up?.flat()?.find(
        (item) => item.key === "estimatedFare"
      )?.value;

      let estimatedFare = '';

      if (rawEstimatedFare) {
        const match = rawEstimatedFare.match(/^([A-Z]+)\s?([\d.]+)$/);
        if (match) {
          const fareCurrency = match[1];
          const fareAmount = match[2];
          estimatedFare = fareAmount;
        }
      }


      // console.log("dateValue 2", dateValue)

      const domain = sessionStorage.getItem("x_company_domain");

      //  console.log("selectedHourlyBookingTime", selectedHourlyBookingTime)

      const postData = {
        phone: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        latitude: pickUp.coords.lat().toString(),
        longitude: pickUp.coords.lng().toString(),
        pickupplace: address,
        dropplace: drop.address,
        drop_latitude: drop.coords.lat().toString(),
        drop_longitude: drop.coords.lng().toString(),
        pickup_time: dateValue
          ? dayjs(dateValue).format("YYYY-MM-DD hh:mm:ss A")
          : moment().format("YYYY-MM-DD hh:mm:ss A"),
        motor_model: selectedModel._id,
        cityname: "",
        distance_away: 0,
        sub_logid: "",
        friend_id2: "0",
        friend_percentage2: "0",
        friend_id3: "0",
        friend_percentage3: "0",
        friend_id4: "0",
        friend_percentage4: "0",
        friend_id1: getUserId(),
        friend_percentage1: "100",
        passenger_payment_option: 1,
        payment_mode: "1",
        approx_distance: distance,
        approx_duration: duration,
        // passenger_id: '56',
        request_type: "1",
        promo_code: "",
        now_after: 1,
        notes: "",
        passenger_app_version: "1",
        pickup_notes: "",
        drop_notes: "",
        drop_makani: "",
        pickup_makani: "",
        is_guest_booking: "0",
        // name: a.firstName + " " + a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        guestInfo: {
          countryCode: `+${a.countryCode}`,
          email: a.email,
          mobileNumber: a.mobileNumber,
          name: a.firstName + " " + a.lastName,
        },
        scheduleBookType: bookType,
        ...(bookType === 4 && {
          requested_trip_hour: selectedHourlyBookingTime,
          hourly_fare: modelHourlyFare,
          approxTripFare: selectedHourlyBookingTime * modelHourlyFare,
        }),
        ...(bookType !== 4 && {
          // approx_fare: estimatedFare,
          approxTripFare: estimatedFare,
        }),
        // approxTripFare: drop.address !== "" ? approxTripFare : 0,
        passenger_cid: companyId,
        companyId: companyId,
        otp: val,
        newUser: items.newUser,
      };

      // console.log("postData", postData);

      // console.log("selectedModel", selectedModel);
      // console.log("postData 2", postData);

      axios
        .post(
          `${BACKEND_URL}/saveBooking?fromWebBooker=1`,
          postData,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}` }
          }
        )
        .then((Response) => {

          if (Response.data.status >= 1) {
            setLoader2(false);

            if (dateValue) {
              setshowErrorMessage(Response.data);

              sessionStorage.setItem(
                "passengerInfo",
                JSON.stringify(Response?.data?.detail?.passengerInfo)
              );

              const obj2 = {
                passengerId: Response.data.detail.passengerInfo.id
              };
              sessionStorage.setItem('passengerId', JSON.stringify(obj2));
            } else {
              getPassengerUpdate(Response.data.detail.passenger_tripid);
            }
          }
          else {
            setAlertMsg(Response.data.message);
            setshowErrorMessage(Response.data);
            setLoader2(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const location = useLocation();

  const params = new URLSearchParams(location.search);
  let pickupCheck = params.get("pickupplace");
  let dropCheck = params.get("dropplace");

  return (
    <Box style={{ flexGrow: 1, marginTop: "8px" }}>
      <Grid container spacing={0} flexDirection="row" alignItems="center">
        <Dialog
          open={openAdd3}
          TransitionComponent={Transition}
          keepMounted
          style={{
            position: "absolute",
            zIndex: 2000,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          maxWidth="xl"
          onClose={handleAddClose3}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent style={{ width: "400px" }}>
            <DialogContentText id="alert-dialog-slide-description">
              <Grid container spacing={3}>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src="/static/images/reject.png"
                    alt="Success"
                    width="100"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h3 style={{ color: "red" }}>{alertMsg}</h3>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleAddClose31}
              variant="contained"
              color="primary"
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                color: "white",
                borderRadius: "4px",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openAdd3Success}
          TransitionComponent={Transition}
          keepMounted
          style={{
            position: "absolute",
            zIndex: 2000,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          maxWidth="xl"
          onClose={handleAddCloseSuccess}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent style={{ width: "400px" }}>
            <DialogContentText id="alert-dialog-slide-description">
              <Grid container spacing={3}>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src="/static/images/greenTick.png"
                    alt="Success"
                    width="100"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h3>{alertMsg}455</h3>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleAddCloseSuccess}
              variant="contained"
              color="primary"
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                color: "white",
                borderRadius: "4px",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openAdd4}
          TransitionComponent={Transition}
          keepMounted
          style={{
            position: "absolute",
            zIndex: 2000,
            top: 0,
            left: 0,
            bottom: 0,
            right: 0,
          }}
          maxWidth="xl"
          onClose={handleAddClose4}
          aria-describedby="alert-dialog-slide-description"
        >
          <DialogContent style={{ width: "400px" }}>
            <DialogContentText id="alert-dialog-slide-description">
              <Grid container spacing={3}>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <img
                    src="/static/images/reject.png"
                    alt="Success"
                    width="100"
                  />
                </Grid>
                <Grid
                  item
                  md={12}
                  style={{ display: "flex", justifyContent: "center" }}
                >
                  <h3 style={{ color: "red" }}>{alertMsg}</h3>
                </Grid>
              </Grid>
            </DialogContentText>
          </DialogContent>
          <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
            <Button
              onClick={handleAddClose41}
              variant="contained"
              color="primary"
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                color: "white",
                borderRadius: "4px",
              }}
            >
              Ok
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={openOtp}
          // onClose={handleCloseOtp}
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
          style={{ boxShadow: "1px 1px 1px 1px" }}
        >
          <DialogTitle
            id="alert-dialog-title"
            style={{ paddingTop: "6px", paddingRight: "14px" }}
          >
            <Grid
              container
              spacing={3}
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <Grid item>{"Please, Enter OTP!"}</Grid>
              <Grid item>
                <CloseIcon
                  onClick={handleCloseOtp}
                  style={{
                    color: "red",
                    border: "1px solid red",
                    cursor: "pointer",
                  }}
                />
              </Grid>
            </Grid>
          </DialogTitle>
          <DialogContent>
            <>
              {
                emailExistMessage &&
                <Grid
                  container
                  spacing={3}
                  style={{ display: "flex", justifyContent: "space-between" }}
                >
                  <Grid item sx={{ fontSize: "14px" }}><span style={{ color: "#FFC107" }}>NOTE:</span> {emailExistMessage}</Grid>
                </Grid>
              }

              <TextField
                id="outlined-basic"
                label="OTP"
                inputProps={{ maxLength: 4 }}
                style={{ marginTop: "25px" }}
                value={val}
                onChange={handleChangeValidate}
                fullWidth
                variant="outlined"
              />
              <a
                style={{
                  fontSize: "13px",
                  marginTop: "5px",
                  color:
                    countDown !== null && countDown !== 0 ? "#9d9d9d" : "blue",
                  pointerEvents:
                    countDown !== null && countDown !== 0 ? "none" : "",
                  cursor:
                    countDown !== null && countDown !== 0 ? "" : "pointer",
                }}
                onClick={() => ResendOtp(pickUp.address)}
                disabled={countDown !== null && countDown !== 0 ? true : false}
              >
                Resend OTP{" "}
                {countDown !== null && countDown !== 0 ? `(${countDown})` : ""}
              </a>
            </>
          </DialogContent>
          <DialogActions>
            <>
              <Button
                onClick={() => BookTaxi(pickUp.address)}
                style={{
                  backgroundColor: companyTheme?.primaryColorCode,
                  borderRadius: "4px",
                  color: "white",
                }}
                disabled={val.length === 4 ? false : true}
                variant="contained"
              >
                {loader2 ? (
                  <CircularProgress style={{ width: "30px", height: "30px", color: "white" }} />
                ) : (
                  "Verify"
                )}
              </Button>
            </>
          </DialogActions>
        </Dialog>
      </Grid>

      <Box>
        <Box
          style={{
            padding: "0px 0px 12px 0px",
            display: "flex",
            alignItems: "center",
            // justifyContent: "space-between",
          }}
        >
          <Box
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
            }}
          ></Box>
        </Box>
        {/* <Divider /> */}
        <Box
          style={{
            display: "flex",
            alignItems: "center",
            marginTop: "8px",
            justifyContent: "end",
          }}
        >
          <Grid container>
            {bookType !== 3 ? (
              <Grid item xs={12}>
                <Box style={{ width: "100%", marginTop: "40px" }}>
                  {(pickUp.address || pickupCheck) &&
                    selectedModel &&
                    (getDriverByModel(driverDetails, selectedModel._id)
                      .length > 0 ||
                      dateValue != null) ? (
                    <Button
                      style={{
                        width: "100%",
                        backgroundColor: companyTheme?.primaryColorCode,
                        borderRadius: "4px",
                      }}
                      variant="contained"
                      color="white"
                      onClick={() => handleOtpCheck()}

                    >
                      {loader3 ? (
                        <CircularProgress
                          style={{ width: "30px", height: "30px", color: "white" }}
                        />
                      ) : (
                        <Typography
                          variant="subtitle2"
                          style={{ fontSize: "14px", color: 'white' }}
                        >
                          {dateValue
                            ? "Schedule at " + dayjs(dateValue).format("YYYY-MM-DD hh:mm:ss A")
                            : "Request " + selectedModel.model_name}
                        </Typography>
                      )}
                    </Button>
                  ) : (
                    <Button
                      style={{
                        width: "100%",
                        backgroundColor: companyTheme?.primaryColorCode,
                        borderRadius: "4px",
                        // marginTop: "8px",
                      }}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        var guetsDetailsLocal =
                          sessionStorage.getItem("guestFinal");
                        var guetsDetailsLocalNew =
                          JSON.parse(guetsDetailsLocal);
                        var a = guetsDetailsLocalNew;

                        // console.log("guetsDetailsLocal" ,guetsDetailsLocal);

                        if (!a ||
                          a.firstName === "" ||
                          a.email === "" ||
                          a.mobileNumber === "" ||
                          pickUp?.address === "" ||
                          drop?.address === "" ||
                          !selectedDays ||
                          !selectedPlan ||
                          selectedDays.length === "" ||
                          selectedDays.length === 0 ||
                          selectedHourlyTime === "" ||
                          time === "" ||
                          planBaseFare === 0 ||
                          twoWayPickupTime === "" ||
                          (selectedPlan.tripType === 2 &&
                            twoWayPickupTime <= time) ||
                          (selectedPlan.tripType === 2 &&
                            selectedHourlyTime === "") ||
                          (startDate && endDate && startDate >= endDate)
                        ) {
                          setAlertMsg("All Fields Are Required");
                          setLoader1(false);
                          setOpenAdd3(true);
                        }

                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{ fontSize: "14px", color: 'white' }}
                      >
                        {pickUp.address || pickupCheck
                          ? selectedModel
                            ? "Currently No driver available"
                            : "Select Model"
                          : "Schedule Pickup"}
                      </Typography>
                    </Button>
                  )}
                </Box>
              </Grid>
            ) : (
              <Grid item xs={12}>
                <Box style={{ width: "100%", marginTop: "40px" }}>
                  {(pickUp.address || pickupCheck) &&
                    selectedModel &&
                    (getDriverByModel(driverDetails, selectedModel._id)
                      .length > 0 ||
                      dateValue != null) ? (
                    <Button
                      style={{
                        width: "100%",
                        backgroundColor: companyTheme?.primaryColorCode,
                        borderRadius: "4px",
                      }}
                      variant="contained"
                      color="primary"
                      onClick={() => BookTaxi(pickUp.address)}
                    >
                      {loader1 ? (
                        <CircularProgress
                          style={{ width: "30px", height: "30px", color: "white" }}
                        />
                      ) : (
                        <Typography
                          variant="subtitle2"
                          style={{ fontSize: "14px", color: "white" }}
                        >
                          Submit Enquiry
                        </Typography>
                      )}
                    </Button>
                  ) : (
                    <Button
                      style={{
                        width: "100%",
                        backgroundColor: companyTheme?.primaryColorCode,
                        borderRadius: "4px",
                        // marginTop: "8px",
                      }}
                      variant="contained"
                      color="primary"
                      onClick={() => {
                        var guetsDetailsLocal =
                          sessionStorage.getItem("guestFinal");
                        var guetsDetailsLocalNew =
                          JSON.parse(guetsDetailsLocal);
                        var a = guetsDetailsLocalNew;

                        if (
                          a.firstName === "" ||
                          a.email === "" ||
                          a.mobileNumber === "" ||
                          pickUp?.address === "" ||
                          drop?.address === ""
                        ) {
                          setAlertMsg("All Fields Are Required");
                          setLoader1(false);
                          setOpenAdd3(true);
                        }
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{ fontSize: "14px", color: 'white' }}
                      >
                        {pickUp.address || pickupCheck
                          ? selectedModel
                            ? "Currently No driver available"
                            : "Select Model"
                          : "Submit Enquiry"}
                      </Typography>
                    </Button>
                  )}
                </Box>
              </Grid>
            )}
          </Grid>
        </Box>
      </Box>
    </Box>
  );
};


export default function NewBookingDesign({
  pickup,
  setPickup,
  drop,
  setDrop,
  waypoints,
  setWaypoints,
  setDriverMarkerData,
  path,
  setPath,
  tripID,
  setTripID,
  setshowErrorMessage,
  showErrorMessage,
  tripData,
  setTripData,
  estimatedTime,
  vehicleModel,
  dateProps,
  timeProps,
  hourlyHire,
  distance,
  duration,
  waydrop,
  setWaydrop,
  pickup1,
  setPickup1,
  drop1,
  setDrop1,
  setPath1,
  waydrop1,
  setWaydrop1,
  onBookingDataChange,
  path1,
  companyId,
  duration2,
  distance2,
  oneWayRoutePolyline,
  twoWayRoutePolyline
}) {

  useEffect(() => {
    sessionStorage.setItem("passengerInfo", null);
    sessionStorage.setItem("passengerId", null);
  }, []);

  const navigate = useNavigate();

  const [detailViewIndex, setDetailViewIndex] = useState(false);
  const [driverDetails, setDriverDetails] = useState();

  const company = sessionStorage.getItem("companyDetails");

  const { companyTheme } = useCompanyTheme();

  // console.log("duration2", duration2);


  const classes = useStyles({ companyTheme });

  const root = document.documentElement;

  root.style.setProperty('--primary-color', companyTheme?.primaryColorCode);
  root.style.setProperty('--secondary-color', companyTheme?.secondaryColorCode);
  root.style.setProperty('--hover-color', companyTheme?.hover);
  root.style.setProperty('--input-focus-color', companyTheme?.primaryColorCode);
  root.style.setProperty('--radio-checked-color', companyTheme?.primaryColorCode);
  root.style.setProperty('--step-dot-color', companyTheme?.primaryColorCode);

  const [searchingCar, setSearchingCar] = useState(false);
  const [searchingDriver, setsearchingDriver] = useState(false);
  const [activeIndexSub, setActiveIndexSub] = useState(null);
  const [selectedPlan, setSelectedPlan] = useState(null);
  const [isValidPlan, setIsValidPlan] = useState(false);
  const [hasFetchedFare, setHasFetchedFare] = useState(false);
  const [subscriptionPlan, setSubscriptionPlan] = useState([]);
  const [defaultPassengerId, setDefaultPassengerId] = useState(null);
  const [distance1, setDistance1] = useState(null);
  const [laterTime, setLaterTime] = useState(60);
  let dateFirst = new Date(new Date().setMinutes(new Date().getMinutes() + laterTime));

  const [dateValue, setDateValue] = useState(new Date());

  const [isHourlyPlan, setIsHourlyPlan] = useState(false);
  const [isRecurringBooking, setIsRecurringBooking] = useState(0);
  const [recurringBookingEnable, setRecurringBookingEnable] = useState(false);
  const [selectedDays, setSelectedDays] = useState([]);
  const [selectedHourlyTime, setSelectedHourlyTime] = useState("");
  const [selectedHourlyBookingTime, setSelectedHourlyBookingTime] = useState(0);
  const [subscriptionTripFare, setSubscriptionTripFare] = useState(null);

  const [twoWayTripFare, setTwoWayTripFare] = useState(null);

  const [totalDaysCount, setTotalDaysCount] = useState(null);

  const [firstWeekDaysCount, setFirstWeekDaysCount] = useState(0);
  const [inBetweenDaysCount, setInBetweenDaysCount] = useState(0);


  const [pickupTimeSlot, setPickupTimeSlot] = useState([]);
  const [dropTimeSlot, setDropTimeSlot] = useState([]);

  const [startDate, setStartDate] = useState(null);

  const [endDate, setEndDate] = useState(null);
  const [dayTimeState, setDayTimeState] = useState({});
  const defaultTime = new Date();

  const [time, setTime] = useState(dayjs().format("HH:mm"));

  const [twoWayPickupTime, setTwoWayPickupTime] = useState(
    dayjs().format("HH:mm")
  );

  useEffect(() => {
    if (
      dateProps !== null &&
      dateProps !== "" &&
      timeProps !== null &&
      timeProps !== ""
    ) {
      var DateTimeProps = dateProps + "T" + timeProps;
      setDateValue(moment(DateTimeProps).format("YYYY-MM-DD hh:mm:ss A"));
    } else if (dateProps !== null && dateProps !== "") {
      var DateTimeProps =
        dateProps + "T" + moment().add(laterTime, "minutes").format("HH:mm");
      setDateValue(moment(DateTimeProps).format("YYYY-MM-DD hh:mm:ss A"));
    } else if (timeProps !== null && timeProps !== "") {
      var DateTimeProps = moment().format("YYYY-MM-DD") + "T" + timeProps;
      setDateValue(moment(DateTimeProps).format("YYYY-MM-DD hh:mm:ss A"));
    } else {
      setDateValue(moment(dateFirst).format("YYYY-MM-DD hh:mm:ss A"));
    }
  }, []);


  // console.log("company-->", companyId);


  const [error, setError] = useState({
    firstName: false,
    lastName: false,
    email: false,
    mobileNumber: false,
    pickupType: false,
  });

  const [fareDetails, setFareDetails] = useState([]);

  const [modelList, setModelList] = useState([
    {
      "modelId": 1,
      "modelName": "SEDAN",
      "description": "Vehicle: LEXUS ES 350, INFINITI, CHEVROLET, BMW\nModel: 2017 - 2020\n\nStarting Fare\nNOW: 7 AED\nLATER: 7 AED\n\nFare (per km): 1.9\n\nWaiting (per hour):  30 (below 10 km/h, billed by minute)\n\nMinimum Fare \nNOW: 20\nLATER: 20\n\nCancellation fee: 5 (after 5 free minutes)\n\nFree waiting time: 5 mins\n\n* Toll fee and waiting fare are not included in the estimated fare",

    },
    {
      "modelId": 10,
      "modelName": "XL",
      "description": "Vehicle: TOYOTA PREVIA, HONDA ODYSSEY, INFINITI QX60, KIA GRAND CARNIVAL, SUBURBAN\nModel: 2017 - 2020\n\nStarting Fare\nNOW: 10 AED\nLATER: 10 AED\n\nFare (per km): 1.9\n\nWaiting (per hour):  30 (below 10 km/h, billed by minute)\n\nMinimum Fare \nNOW: 20\nLATER: 20\n\nCancellation fee: 5 (after 5 free minutes)\n\nFree waiting time: 5 min\n\n* Toll fee and waiting fare are not included in the estimated fare",
    },
    {
      "modelId": 23,
      "modelName": "VIP",
      "description": "Vehicle: Mercedes, Maserati, BMW\nModel: 2017 - 2020\n\nStarting Fare\nNOW: 15\nLATER: 15\n\nFare (per km): 4\n\nWaiting (per hour):  60 (below 10 km/h, billed by minute)\n\nMinimum Fare \nNOW: 50\nLATER: 50\n\nCancellation fee: 5 (after 5 free minutes)\n\nFree waiting time: 5 min\n\n* Toll fee and waiting fare are not included in the estimated fare",
    },
    {
      "modelId": 19,
      "modelName": "VIP PLUS",
      "description": "Vehicle: Cadillac Escalade\n\nModel:2017-2019\nStarting Fare\nNOW: 15\nLATER: 15\n\nFare (per km): 4\n\nWaiting (per hour):  60 (below 10 km/h, billed by minute)\n\nMinimum Fare \nNOW: 50\nLATER: 50\n\nCancellation fee: 5 (after 5 free minutes)\n\nFree waiting time: 5 min\n\n* Toll fee and waiting fare are not included in the estimated fare",
    },
    {
      "modelId": 14,
      "modelName": "AE EXPRESS PICKUP",
      "description": "Vehicle: PICKUP (1 TON)\nModel: 2010 - 2020\n\nStarting Fare\nNOW: 10\nLATER: 10\n\nMoving (per km): 2.1\nWaiting (per hour):  60 (below 20 km/h, billed by minute)\n\nMinimum Fare \nNOW: 100\nLATER: 100",

    }
  ]);

  const [fareDetails1, setFareDetails1] = useState([]);
  const [hourlyFareSplitup, setHourlyFareSplitup] = useState([]);
  const [subscriptionFareSplitup, setSubscriptionFareSplitup] = useState([]);

  const [splitDetails, setSplitDetails] = useState([]);

  const [selectedModel, setSelectedModel] = useState(null);
  var guest = {};
  const [bookNow, setBookNow] = useState(false);

  const [fullLoader, setFullLoader] = useState(0);
  const [driverETA, setDriverETA] = useState(0);
  const [transferStatus, setTransferStatus] = useState(true);
  const [fullDayStatus, setFullDayStatus] = useState(false);
  const [halfDayStatus, setHalfDayStatus] = useState(false);
  const [subscriptionStatus, setSubscriptionStatus] = useState(false);
  const [hourlyStatus, setHourlyStatus] = useState(false);
  const [bookType, setBookType] = useState(0);
  let pickUpLatLng = { lat: 0.0, lng: 0.0 };
  const [userInteracting, setUserInteracting] = useState(true);
  const [approxTripFare, setApproxTripFare] = useState(0);
  const [baseFare, setBaseFare] = useState();
  const [planBaseFare, setPlanBaseFare] = useState();
  const [modelHourlyFare, setModelHourlyFare] = useState();

  const [twoWayBaseFare, setTwoWayBaseFare] = useState();

  const [activeIndex, setActiveIndex] = useState(0);

  const { setCompany } = useCompanyTheme();

  const [checkFalse, setCheckFalse] = useState(true);
  const [pathValue, setPathValue] = useState([]);
  const [addressJson, setAddressJson] = useState({
    addressPickup: "",
    addressDrop: "",
    distAddress: null,
    durationAddress: null,
    polylineAddress: "",
  });

  const handleWaypointChange = (index, value) => {
    const updated = [...waypoints];
    updated[index] = value; // Update the waypoint at the specific index
    setWaypoints(updated);
    setWaydrop(updated);
  };


  const hasFetchedConfig = useRef(false);
  const dateValRef = useRef(dateValue);
  useEffect(() => {
    dateValRef.current = dateValue;
  }, [dateValue]);

  // 1) Fetch once on mount
  useEffect(() => {
    // if (hasFetchedConfig.current) return;  // <— bail out if we’ve already run
    // hasFetchedConfig.current = true;

    const obj = {
      // domainName: window.location.hostname
      domainName: 'webbooker.limor.us'
    }


    axios
      .post(`${BACKEND_URL}/getCompanyInfo?fromWebBooker=1`, obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        })
      .then((response) => {
        if (response?.data?.status === 1) {

          setCompany(response.data.responseData);

          // console.log("companyDetails", companyDetails)

        } else {
          setLaterTime(30);
        }
      })
      .catch((error) => {
        console.error(error);
        setLaterTime(30);
      });

    axios
      .get(`${BACKEND_URL}/getCoreConfig?fromWebBooker=1`, {
        headers: { Authorization: `Bearer ${ANON_KEY}` }
      })
      .then((response) => {
        if (response?.data?.status === 1) {
          const bufferTime = response.data.details.schedule_booking_buffer_time_mins ?? 30;
          setLaterTime(bufferTime);
          setDateValue(
            moment()
              .add(bufferTime, 'minutes')
              .format('YYYY-MM-DD hh:mm:ss A')
          );
        } else {
          setLaterTime(30);
        }
      })
      .catch((error) => {
        console.error(error);
        setLaterTime(30);
      });
  }, []);


  useEffect(() => {

    if (distance1 !== distance) {
      setDistance1(distance)
    }
  }, [distance]);
  const inFlightRef = useRef(false);
  const lastHashRef = useRef("");

  useEffect(() => {
    // ------- guards (only numbers/primitives in checks) -------
    const hasPickup =
      typeof pickup?.coords?.lat === "function" &&
      typeof pickup?.coords?.lng === "function" &&
      pickup.coords.lat() !== 0 &&
      pickup.coords.lng() !== 0;

    const hasDrop =
      typeof drop?.coords?.lat === "function" &&
      typeof drop?.coords?.lng === "function" &&
      drop.coords.lat() !== 0 &&
      drop.coords.lng() !== 0;

    const hasModel = !!(selectedModel && selectedModel._id);
    const hasPath = !!path;         // path can be encoded string OR array
    const hasDistance = typeof distance === "number" && distance > 0;

    // two-way indicators
    const hasTwoWayExtras =
      !!drop1?.address && !!path1 && typeof distance2 === "number" && distance2 > 0 && bookType === 3;

    // base condition (your "called 1")
    const canFetchOneWay = hasPickup && hasDrop && hasModel && hasPath && hasDistance;

    if (!canFetchOneWay) {
      // mirror your original behavior
      setSelectedHourlyBookingTime?.(0);
      return;
    }

    // ------- build payload (one call for both cases) -------

    // console.log("distance 1",distance );
    // console.log("distance 2",distance2);
    // console.log("avg",(distance + distance2) / 2);

    const payload = {
      corporate_id: 0,
      pickup_latitude: pickup.coords.lat(),
      pickup_longitude: pickup.coords.lng(),
      company_id: companyId,
      zone_fare_applied: 0,
      distance: hasTwoWayExtras ? (distance + distance2) / 2 : distance,
      model_id: selectedModel._id || 0,
      overview_polyline: path,
      ...(hasTwoWayExtras
        ? { twoway_overview_polyline: path1 }
        : { drop_latitude: drop.coords.lat(), drop_longitude: drop.coords.lng() }),
      ...(bookType === 3
        ? { isSubscriptionEnquiry: 1, subscription_id: selectedPlan?._id }
        : {}),
    };

    // stable signature: prevents same-input re-fetches
    const payloadHash = JSON.stringify({
      bookType,
      companyId,
      model: selectedModel._id,
      pickup: [payload.pickup_latitude, payload.pickup_longitude],
      drop: hasTwoWayExtras ? null : [drop.coords.lat(), drop.coords.lng()],
      distance: payload.distance,
      overview: typeof path === "string" ? path : JSON.stringify(path),
      twoway: hasTwoWayExtras
        ? (typeof path1 === "string" ? path1 : JSON.stringify(path1))
        : null,
      subscription_id: selectedPlan?._id || null,
    });

    // ------- dedupe guards -------
    if (inFlightRef.current) return;               // a request is already running
    if (lastHashRef.current === payloadHash) return; // same inputs already fetched

    inFlightRef.current = true;     // lock immediately
    lastHashRef.current = payloadHash;

    (async () => {
      try {
        // console.log("fare API: start");
        const { data } = await axios.post(
          `${ADMIN_BACKEND_URL}/getFare?fromWebBooker=1`,
          payload,
          { headers: { Authorization: `Bearer ${ANON_KEY}` } }
        );

        if (data?.status === 1) {
          const fareDetailsObj = data.details?.carMakeFare;
          if (fareDetailsObj) {
            setFareDetails1?.(fareDetailsObj);
            setPlanBaseFare?.(fareDetailsObj.fare);
            if (hasTwoWayExtras) setTwoWayBaseFare?.(fareDetailsObj.fare);
          }
          setSearchingCar?.(false);
          setHasFetchedFare?.(true);
        }
      } catch (err) {
        console.error(err);
      } finally {
        inFlightRef.current = false; // release lock
      }
    })();
  }, [
    // primitives/stable signatures only
    bookType,
    companyId,
    selectedPlan?._id,
    selectedModel?._id,
    distance,
    distance2,
    // stabilize coords & paths (avoid object/array ref churn)
    pickup?.coords && `${pickup.coords.lat?.()},${pickup.coords.lng?.()}`,
    drop?.coords && `${drop.coords.lat?.()},${drop.coords.lng?.()}`,
    drop1?.address || "",
    typeof path === "string" ? path : JSON.stringify(path || null),
    typeof path1 === "string" ? path1 : JSON.stringify(path1 || null),
  ]);


  useEffect(() => {
    if (hourlyHire !== null) {
      if (hourlyHire <= 12) {
        setBookType(2);

        setFullDayStatus(false);
        setTransferStatus(false);
        setHalfDayStatus(true);
      } else {
        setBookType(1);

        setHalfDayStatus(false);
        setTransferStatus(false);
        setFullDayStatus(true);
      }
    }
  }, []);

  useEffect(() => {
    if (hourlyHire !== null) {
      if (hourlyHire <= 12) {
        if (fareDetails[activeIndex]) {
          setBookType(2);

          setApproxTripFare(fareDetails[activeIndex].half_day);

          setFullDayStatus(false);
          setTransferStatus(false);
          setHalfDayStatus(true);
        }
      } else {
        if (fareDetails[activeIndex]) {
          setBookType(1);

          setApproxTripFare(fareDetails[activeIndex].full_day);

          setHalfDayStatus(false);
          setTransferStatus(false);
          setFullDayStatus(true);
        }
      }
    }
  }, [fareDetails]);




  function useInterval(callback, delay) {
    const savedCallback = useRef();

    // Remember the latest callback.
    useEffect(() => {
      savedCallback.current = callback;
    }, [callback]);

    // Set up the interval.
    useEffect(() => {
      function tick() {
        savedCallback.current();
      }
      if (delay !== null) {
        let id = setInterval(tick, delay);
        return () => clearInterval(id);
      }
    }, [delay]);
  }

  //naga
  // useEffect(() => {


  //   // console.log("pickup");

  //   if (pickup) {
  //     pickUpLatLng = pickup.coords;
  //     setCheckFalse(true);
  //     setSearchingCar(true);
  //     if (
  //       pickup.address !== "" &&
  //       addressJson.addressPickup !== pickup.address 
  //     ) {
  //       // setDirectionRestric(1);
  //       setAddressJson({ ...addressJson, ["addressPickup"]: pickup.address });
  //       getNearestDriver(
  //         pickUpLatLng.lat() ? pickUpLatLng.lat() : "0.0",
  //         pickUpLatLng.lng() ? pickUpLatLng.lng() : "0.0",
  //         drop.coords.lat() ? drop.coords.lat() : "0.0",
  //         drop.coords.lng() ? drop.coords.lng() : "0.0",
  //         setDriverETA,
  //         1,

  //       );

  //       // console.log('pickup', pickup.address, typeof pickup.address);
  //     } else {
  //       setAddressJson({ ...addressJson, ["addressPickup"]: pickup.address });
  //       getNearestDriver(
  //         pickUpLatLng.lat() ? pickUpLatLng.lat() : "0.0",
  //         pickUpLatLng.lng() ? pickUpLatLng.lng() : "0.0",
  //         drop.coords.lat() ? drop.coords.lat() : "0.0",
  //         drop.coords.lng() ? drop.coords.lng() : "0.0",
  //         setDriverETA,
  //         1
  //       );
  //     }
  //   }
  // }, [pickup]);

  const modelFareCalled = useRef(false);

  useEffect(() => {
    if (!pickup) return;

    const pickupLat = pickup.coords?.lat();
    const pickupLng = pickup.coords?.lng();
    const dropLat = drop?.coords?.lat();
    const dropLng = drop?.coords?.lng();

    // ✅ Case 1: all values available → call getFare
    if (pickupLat && pickupLng && dropLat && dropLng && path && distance && selectedModel) {
      getNearestDriver(
        pickupLat,
        pickupLng,
        dropLat,
        dropLng,
        setDriverETA,
        1,
        path,
        distance,
        selectedModel
      );
    }
    // ✅ Case 2: fallback → only call /modelFareDetails ONCE
    else if (!modelFareCalled.current) {
      getNearestDriver(
        pickupLat || "0.0",
        pickupLng || "0.0",
        dropLat || "0.0",
        dropLng || "0.0",
        setDriverETA,
        1
      );
      modelFareCalled.current = true; // prevent multiple calls
    }
  }, [pickup, drop, path, distance, selectedModel]);



  // console.log("selectedModel", selectedModel);

  // console.log("bookType", bookType)

  // useEffect(() => {

  //   if (onBookingDataChange) {
  //     onBookingDataChange({
  //       fareDetails: fareDetails1,
  //       selectedModel: selectedModel,
  //       bookType: bookType,
  //       hourlyFareSplitup: hourlyFareSplitup,
  //     });
  //   }

  // }, [onBookingDataChange, fareDetails1, selectedModel, bookType, hourlyFareSplitup]);


  // console.log("totalDaysCount", totalDaysCount);


  useEffect(() => {
    if (onBookingDataChange) {
      const payload = {
        fareDetails: fareDetails1,
        selectedModel,
        bookType,
        ...(bookType === 3 && subscriptionTripFare && subscriptionTripFare !== null && totalDaysCount && totalDaysCount !== 0 && planBaseFare && planBaseFare !== 0
          ? {
            subscriptionFareSplitup
          }
          : {}),

      };

      onBookingDataChange(payload);
    }
  }, [
    onBookingDataChange,
    fareDetails1,
    selectedModel,
    bookType,
    hourlyFareSplitup,
    selectedHourlyBookingTime,
    subscriptionTripFare,
    twoWayTripFare,
    totalDaysCount,
    subscriptionFareSplitup,
    planBaseFare
  ]);


  // console.log("planBaseFare",planBaseFare);
  // console.log("totalDaysCount",totalDaysCount);
  // console.log("twoWayBaseFare",twoWayBaseFare);



  // useEffect(() => {
  //   if (
  //     bookType === 4 &&
  //     fareDetails.length > 0 &&
  //     distance &&
  //     distance > 0 &&
  //     selectedHourlyBookingTime != null
  //   ) {
  //     const updatedFareDetails = fareDetails.map(item => {
  //       const baseFare = item.hourly_fare || 0;
  //       const distanceFare = baseFare * selectedHourlyBookingTime;

  //       const formatCurrency = (value) =>
  //         `AED ${Number(value).toFixed(2).replace(/\.00$/, '')}`;

  //       const formatDistance = (value) =>
  //         `${Number(value).toFixed(2).replace(/\.00$/, '')} km`;

  //       return {
  //         ...item,
  //         split_up: [[
  //           {
  //             key: 'baseFare',
  //             formatted_key: 'Fare Per Hour',
  //             value: formatCurrency(baseFare),
  //           },
  //           {
  //             key: 'duration',
  //             formatted_key: 'Duration',
  //             value: `${selectedHourlyBookingTime} Hrs`,
  //           },
  //           {
  //             key: 'distance',
  //             formatted_key: 'Distance',
  //             value: formatDistance(distance),
  //           },
  //           {
  //             key: 'distanceFare',
  //             formatted_key: 'Distance Fare',
  //             value: formatCurrency(distanceFare),
  //           },
  //         ]]
  //       };
  //     });

  //     setHourlyFareSplitup(updatedFareDetails);
  //   }
  // }, [fareDetails, bookType, distance, selectedHourlyBookingTime]);

  useEffect(() => {
    if (
      bookType === 4 &&
      fareDetails1 &&
      distance &&
      distance > 0 &&
      selectedHourlyBookingTime != null
    ) {
      const baseFare = fareDetails1.hourly_fare || 0;
      const distanceFare = baseFare * selectedHourlyBookingTime;

      const formatCurrency = (value) =>
        `AED ${Number(value).toFixed(2).replace(/\.00$/, '')}`;

      const formatDistance = (value) =>
        `${Number(value).toFixed(2).replace(/\.00$/, '')} km`;

      const updatedFareDetails = {
        ...fareDetails1,
        split_up: [[
          {
            key: 'baseFare',
            formatted_key: 'Fare Per Hour',
            value: formatCurrency(baseFare),
          },
          {
            key: 'duration',
            formatted_key: 'Duration',
            value: `${selectedHourlyBookingTime} Hrs`,
          },
          {
            key: 'distance',
            formatted_key: 'Distance',
            value: formatDistance(distance),
          },
          {
            key: 'distanceFare',
            formatted_key: 'Distance Fare',
            value: formatCurrency(distanceFare),
          },
        ]]
      };

      setHourlyFareSplitup(updatedFareDetails);
    }
  }, [fareDetails1, bookType, distance, selectedHourlyBookingTime]);



  // console.log("fareDetails", fareDetails);
  // console.log("fareDetails1", fareDetails1);


  useEffect(() => {
    if (
      bookType === 3 &&
      subscriptionTripFare != null &&
      totalDaysCount !== 0 &&
      planBaseFare !== ''
    ) {
      let count;
      if (selectedPlan?.tripType === 2) {

        count = totalDaysCount * 2;
      }
      else {
        count = totalDaysCount;
      }


      const formatCurrency = (value) =>
        `AED ${Number(value).toFixed(2).replace(/\.00$/, '')}`;

      const isTwoWayEmptyOrZero =
        !twoWayTripFare || Number(twoWayTripFare) === 0;

      const splitUp = [

        [{
          key: 'totalDaysCount',
          formatted_key: 'Total Days',
          value: totalDaysCount
        }],
        [
          {
            key: 'oneWayFare',
            formatted_key: 'Total Fare',
            value: formatCurrency(planBaseFare),
          },

          // ...(!isTwoWayEmptyOrZero
          //   ? [
          //     {
          //       key: 'twoWayTripFare',
          //       formatted_key: 'Total Fare',
          //       value: formatCurrency(twoWayBaseFare),
          //     },
          //   ]
          //   : [])
        ]
      ];

      setSubscriptionFareSplitup(splitUp);

    }
  }, [
    bookType,
    subscriptionTripFare,
    totalDaysCount,
    planBaseFare,
    twoWayTripFare,
    firstWeekDaysCount,
    inBetweenDaysCount,
    twoWayBaseFare
  ]);




  // console.log("firstWeekDaysCount", firstWeekDaysCount);

  // console.log("pickup.coords.lat() !== '' && drop.coords.lat() ", pickup.coords.lat() , drop.coords.lat() );


  useEffect(() => {
    if (checkFalse) {
      let model = fareDetails[activeIndex];
      if (model) {
        setActiveIndex(activeIndex);
        // var obj = {
        //   modelId: model.modelId,
        //   modelName: model.modelName,
        //   fare: model.fare,
        //   description: model.description,
        //   image: `/static/images/${vehicleArray[activeIndex].vehicleType}.png`,
        // };
        // setSelectedModel(obj);
        const matchingFare = fareDetails.find(
          (detail) => detail.modelId === model.modelId
        );
        // console.log("matchingFare",matchingFare);
        setSelectedModel(matchingFare);

        if (matchingFare) {
          setPlanBaseFare(matchingFare.fare);
        }

        // if (bookType === 0) {
        //   setApproxTripFare(obj.fare);
        // } else if (bookType === 1) {
        //   setApproxTripFare(obj.full_day);
        // } else if (bookType === 2) {
        //   setApproxTripFare(obj.half_day);
        // } else if (bookType === 3) {
        //   setApproxTripFare(obj.fare);
        // }
      }
    }
  }, [fareDetails]);

  useEffect(() => {
    if (vehicleModel !== null && vehicleModel !== "") {
      setActiveIndex(0);
      setModelCat(TaxiModelArray[0].toString());
      TaxiModelArray.map((item, index) => {
        if (item.includes(vehicleModel)) {
          setActiveIndex(index);
          setModelCat(TaxiModelArray[index].toString());
        }
      });
    }
  }, []);

  const API_KEY = process.env.REACT_APP_CURRENT_API_KEY;

  const [country, setCountry] = useState("us");
  const { ref: materialRef } = usePlacesWidget({
    apiKey: API_KEY,
    inputAutocompleteValue: "country",
    options: {
      componentRestrictions: {
        country,
      },
    },
  });

  function getNearestDriver(
    pickupLat,
    pickupLng,
    dropLat,
    dropLng,
    setDriverETA,
    checkDirection,
    path = null,
    distance = null,
    selectedModel = null
  ) {
    const companyId = Number(sessionStorage.getItem("companyId"));

    // ✅ check if full details are available for fare API
    const canGetFare =
      pickupLat &&
      pickupLng &&
      dropLat &&
      dropLng &&
      path &&
      distance &&
      selectedModel?.model_id;

    if (canGetFare) {
      const obj = {
        corporate_id: 0,
        pickup_latitude: pickupLat,
        pickup_longitude: pickupLng,
        drop_latitude: dropLat,
        drop_longitude: dropLng,
        company_id: companyId,
        zone_fare_applied: 0,
        distance,
        model_id: selectedModel?._id || 0,
        overview_polyline: path,
        ...(bookType === 3
          ? {
            isSubscriptionEnquiry: 1,
            subscription_id: selectedPlan?._id,
          }
          : {}),
      };

      // console.log("called neares");

      axios
        .post(`${ADMIN_BACKEND_URL}/getFare?fromWebBooker=1`, obj, {
          headers: { Authorization: `Bearer ${ANON_KEY}` },
        })
        .then((Response) => {
          if (Response.data.status === 1) {
            let fareDetailsObj = Response.data.details?.carMakeFare;
            setFareDetails1(fareDetailsObj);
            setPlanBaseFare(fareDetailsObj.fare);
            setModelHourlyFare(fareDetailsObj.hourly_fare);
            setSearchingCar(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } else {
      // ✅ fallback → only companyId known
      const obj = { type: 1, company_id: companyId };

      axios
        .post(`${ADMIN_BACKEND_URL}/modelFareDetails?fromWebBooker=1`, obj, {
          headers: { Authorization: `Bearer ${ANON_KEY}` },
        })
        .then((Response) => {
          if (Response.data.status === 1) {
            let fareDetailsObj = Response.data.responseData;
            setFareDetails(fareDetailsObj);
            setSearchingCar(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }


  window.FontAwesomeConfig = {
    searchPseudoElements: true,
  };

  const ExtraForm = (props) => {
    const ref0 = useRef();
    const location = useLocation();

    const params = new URLSearchParams(location.search);

    const [dummy, setDummy] = useState({
      firstName: params.get("name") ? params.get("name") : "",
      lastName: params.get("name") ? params.get("name") : "",
      email: params.get("email") ? params.get("email") : "",
      countryCode: "971",
      mobileNumber: params.get("mobile_number")
        ? params.get("mobile_number")
        : "",
      profileImage: "",
    });

    const [error, setError] = useState({
      firstName: false,
      lastName: false,
      email: false,
      mobileNumber: false,
      pickupType: false,
    });
    const [countryCodeTemp, setCountryCodeTemp] = useState({
      code: "AE",
      phone: "971",
    });
    const [phoneCheck, setPhoneCheck] = useState(null);
    const [sessionVl, setSessionVl] = useState(null);
    const [sessionVl1, setSessionVl1] = useState(null);

    useEffect(() => {
      const items = JSON.parse(sessionStorage.getItem("passengerInfo"));

      // console.log("items",items);

      const items1 = JSON.parse(sessionStorage.getItem("passengerId"));
      // console.log("items 1",items1 );
      setSessionVl1(items1);
      setSessionVl(items);
      if (items !== null) {
        setDummy({
          ...dummy,
          firstName: items.firstName,
          lastName: items.lastName,
          email: items.email,
          countryCode: items.countryCode,
          mobileNumber: items.phone,
          profileImage: items.profileImage,
        });
        setCountryCodeTemp({
          ...countryCodeTemp,
          ["phone"]: items.countryCode,
        });
      }
    }, []);

    var countryCodeDum = {};

    const handleInputChange = (e, otpField, code) => {
      if (e === "countryCode") {
        setDummy({ ...dummy, [e]: otpField });
        setCountryCodeTemp({ code: code, phone: otpField });
      } else {
        let { name, value } = e.target;

        setDummy({ ...dummy, [name]: value });

        setError((prev) => ({
          ...prev,
          [name]: value.trim() === ""
        }));

      }
    };

    useEffect(() => {
      if (dummy.firstName !== "") {
        sessionStorage.setItem("guestFinal", JSON.stringify(dummy));
        const obj = {
          firstName: dummy.firstName,
          lastName: dummy.lastName,
          email: dummy.email,
          countryCode: dummy.countryCode,
          phone: dummy.mobileNumber,
          profileImage: dummy.profileImage,
        };

        sessionStorage.setItem("passengerInfo", JSON.stringify(obj));
        setCountryCodeTemp({
          ...countryCodeTemp,
          ["phone"]: dummy.countryCode,
        });
      }
    }, [dummy]);

    useEffect(() => {
      var guetsDetailsLocal = sessionStorage.getItem("passengerInfo");
      var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
      if (pickup.address !== "") {
        var a = guetsDetailsLocalNew;
        if (a) {
          setDummy({
            ...dummy,
            firstName: a.firstName,
            lastName: a.lastName,
            email: a.email,
            countryCode: a.countryCode,
            mobileNumber: a.phone,
            profileImage: a.profileImage,
          });
        }
      }
    }, [pickup]);


    window.addEventListener("load", (event) => {
      if (dummy.firstName === "") {
        sessionStorage.setItem("guestFinal", JSON.stringify(dummy));
      } else {
        sessionStorage.removeItem("guestFinal");
      }
    });


    function countryToFlag(isoCode) {
      return typeof String.fromCodePoint !== "undefined"
        ? isoCode
          .toUpperCase()
          .replace(/./g, (char) =>
            String.fromCodePoint(char.charCodeAt(0) + 127397)
          )
        : isoCode;
    }

    const handlePhoneCheck = () => {
      setPhoneCheck("If you want change phone number, please logout!");
    };

    const handlePhoneCheck1 = () => {
      setPhoneCheck("");
    };

    useEffect(() => {
      const items = JSON.parse(sessionStorage.getItem("passengerInfo"));
      const items1 = JSON.parse(sessionStorage.getItem("passengerId"));
      setSessionVl1(items1);
      setSessionVl(items);
      if (items !== null) {
        setDummy({
          ...dummy,
          firstName: items.firstName,
          lastName: items.lastName,
          email: items.email,
          countryCode: items.countryCode,
          mobileNumber: items.phone,
          profileImage: items.profileImage,
        });
        setCountryCodeTemp({
          ...countryCodeTemp,
          phone: items.countryCode,
        });
      }
    }, []);
    return (
      <>

        <VehicleDisplay
          setDetailViewIndex={setDetailViewIndex}
          fareDetails={fareDetails}
          fareDetails1={fareDetails1}
          modelList={modelList}
          driverDetails={driverDetails}
          setSelectedModel={setSelectedModel}
          setDriverMarkerData={setDriverMarkerData}
          driverETA={driverETA}
          bookType={bookType}
          pickUp={pickup}
          selectedModel={selectedModel}
          drop={drop}
          setActiveIndex={setActiveIndex}
          activeIndex={activeIndex}
          setApproxTripFare={setApproxTripFare}
          setModelCat={setModelCat}
          modelCat={modelCat}
          baseFare={baseFare}
          setBaseFare={setBaseFare}
          planBaseFare={planBaseFare}
          setPlanBaseFare={setPlanBaseFare}
          setTwoWayBaseFare={setTwoWayBaseFare}
          twoWayBaseFare={twoWayBaseFare}
          splitDetails={splitDetails}
          companyId={companyId}
          companyTheme={companyTheme}
        />
        {/* )} */}

        <Box sx={{ marginTop: "8px", backgroundColor: "#f9fafb" }}>
          <Grid container spacing={1} alignItems="center" marginTop="8px">


            {/* <Grid item xs={4} className={classes.formContent}>
              <Box style={{ width: "200px" }}>

                <Typography
                  style={{ fontSize: "14px", fontWeight: "400", }}
                  variaint="subtitle2"
                >
                   Name
                </Typography>
              </Box>
            </Grid>

            <Grid item xs={8} className={classes.formContent}>
              <TextField
                error={error.name}
                variant="outlined"
                type="text"
                placeholder="Name"
                className="name"
                name="name"
                value={dummy.name !== "" ? dummy.name : ""}
                size="small"
                fullWidth
                onChange={(e) => handleInputChange(e)}
              />
            </Grid> */}


            {/* First Name */}
            <Grid item xs={4} className={classes.formContent}>
              <Box style={{ width: "200px" }}>
                <Typography style={{ fontSize: "14px", fontWeight: "400" }} variant="subtitle2">
                  First Name:
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8} className={classes.formContent}>
              <TextField
                error={error.firstName}
                helperText={error.firstName ? "Please enter a valid first name" : ""}
                variant="outlined"
                type="text"
                placeholder="First Name"
                className="firstName"
                name="firstName"
                value={dummy.firstName || ""}
                size="small"
                fullWidth
                onChange={handleInputChange}
              />
            </Grid>

            {/* Last Name */}
            <Grid item xs={4} className={classes.formContent}>
              <Box style={{ width: "200px" }}>
                <Typography style={{ fontSize: "14px", fontWeight: "400" }} variant="subtitle2">
                  Last Name:
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8} className={classes.formContent}>
              <TextField
                error={error.lastName}
                helperText={error.lastName ? "Please enter a valid last name" : ""}
                variant="outlined"
                type="text"
                placeholder="Last Name"
                className="lastName"
                name="lastName"
                value={dummy.lastName || ""}
                size="small"
                fullWidth
                onChange={handleInputChange}
              />
            </Grid>




            <Grid item xs={4} className={classes.formContent}>
              <Box style={{ width: "200px" }}>
                <Typography
                  style={{ fontSize: "14px", fontWeight: "400", }}
                  variaint="subtitle2"
                >
                  Email:
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8} className={classes.formContent}>
              <TextField
                error={error.email}
                helperText={error.email ? "Please enter a valid email" : ""}
                variant="outlined"
                type={"email"}
                name="email"
                className="email"
                placeholder="Email"
                size="small"
                fullWidth
                value={dummy.email}
                onInput={
                  (e) =>
                  (e.target.value = e.target.value
                    .replace(/\s/g, "")
                    .slice(0, 50))
                }
                onChange={(e) => handleInputChange(e)}
              />
            </Grid>
            <Grid item xs={4} className={classes.formContent}>
              <Box style={{ width: "200px" }}>
                {" "}
                <Typography
                  style={{ fontSize: "14px", fontWeight: "400", }}
                  variaint="subtitle2"
                >
                  Mobile Number:
                </Typography>
              </Box>
            </Grid>
            <Grid item xs={8} className={classes.formContent}>
              <Box
                id="countryCode"
                style={{ display: "flex", flexDirection: "row", width: "100%" }}
              >
                <Autocomplete
                  style={{ width: "30%" }}
                  defaultValue={countryCodeTemp}
                  // value={countries.find(country => country.phone === countryCodeTemp)}
                  value={countries.find(
                    (country) => country.phone === countryCodeTemp.phone
                  )}
                  name="countryCode"
                  id="countryCode"
                  ref={ref0}
                  // open={true}
                  disabled={sessionVl1 !== null ? true : false}
                  onChange={(e, newValue) =>
                    handleInputChange(
                      ref0.current.getAttribute("name"),
                      newValue.phone,
                      newValue.code
                    )
                  }
                  // onChange={(e, newValue) => // console.log(newValue)}
                  freeSolo
                  disableClearable="true"
                  options={countries}
                  classes={{
                    option: classes.option,
                    paper: classes.countryCode,
                    inputRoot: classes.inputRoot,
                    input: classes.input,
                  }}
                  className={classes.mobileCountry}
                  autoHighlight
                  getOptionLabel={(option) => `${option.code}+${option.phone}`}
                  renderOption={(option) => (
                    <React.Fragment>
                      <span>{countryToFlag(option.code)}</span>
                      {option.label} ({option.code}) +{option.phone}
                    </React.Fragment>
                  )}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      size="small"
                      placeholder="Code"
                      onClick={(params) => (params.target.value = "")}
                      // label="Choose a country"
                      className={classes.mobileCountry}
                      variant="outlined"
                      inputProps={{
                        ...params.inputProps,
                        autoComplete: "new-password", // disable autocomplete and autofill
                      }}
                    />
                  )}
                />
                <Tooltip title={sessionVl1 !== null ? phoneCheck : ""}>
                  <TextField
                    style={{ width: "100%" }}
                    id="standard-basic"
                    error={error.mobileNumber}
                    helperText={error.mobileNumber ? "Please enter a valid mobile" : ""}
                    type={"tel"}
                    onInput={(e) => {
                      let inputValue = e.target.value;

                      // Remove non-numeric characters
                      inputValue = inputValue.replace(/[^0-9]/g, "");

                      // Remove leading zero if it's the first character
                      if (
                        inputValue.length > 0 &&
                        inputValue.charAt(0) === "0"
                      ) {
                        inputValue = inputValue.slice(1);
                      }

                      // Limit the input to 10 characters
                      inputValue = inputValue.slice(0, 10);

                      // Update the input value
                      e.target.value = inputValue;
                    }}
                    variant="outlined"
                    pattern="[0-9]"
                    onMouseEnter={() => handlePhoneCheck()}
                    onMouseLeave={() => handlePhoneCheck1()}
                    className="mobileNum"
                    size="small"
                    disabled={sessionVl1 !== null ? true : false}
                    inputProps={{ maxLength: 11 }}
                    // value={props.apiData.mobileNumber}
                    name="mobileNumber"
                    value={dummy.mobileNumber}
                    onChange={(e) => handleInputChange(e)}
                    InputProps={{
                      endAdornment: (
                        <InputAdornment position="end">
                          {/* <PhoneAndroidIcon style={{ color: companyTheme?.primaryColorCode }} /> */}
                        </InputAdornment>
                      ),
                    }}
                  />
                </Tooltip>
              </Box>
            </Grid>
          </Grid>
        </Box>
        {/* </Grid>
        </Box> */}
      </>
    );
  };

  const AddressSearchBar = ({ setDateValue }) => {
    const [waydrop, setWaydrop] = useState([]);

    const handleAddDrop = () => {
      const newPoint = { location: {} };
      setWaypoints([...waypoints, newPoint]);
      setWaydrop([...waypoints, newPoint]);
    };

    const handleRemoveDrop = (index) => {
      const updatedWayPath = [...wayPath];
      updatedWayPath.splice(index, 1);
      setWayPath(updatedWayPath);

      const updatedWaypoints = [...waypoints];
      updatedWaypoints.splice(index, 1);
      setWaypoints(updatedWaypoints);
      setWaydrop(updatedWaypoints);
    };


    // console.log("waypoints",waypoints);


    return (
      <Box sx={{ marginTop: "8px", backgroundColor: "#f9fafb" }}>
        <Grid container spacing={0} alignItems="center">
          <Grid item xs={4} className={classes.formContent}>
            <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
              Pickup & Drop:
            </Typography>
          </Grid>

          <Grid item xs={8} className={classes.formContent}>
            <ol className="c-stepper" style={{ padding: 0 }}>
              {/* Pickup Location */}
              <li className="c-stepper__item">
                <div className="c-stepper__content">
                  <h3 className="c-stepper__title">
                    <MaterialAuto
                      className="pickup"
                      type="pickup"
                      drop={drop}
                      pickup={pickup}
                      setPickup={setPickup}
                      setPath={setPath}
                      setDrop={setDrop}
                      setUserInteracting={setUserInteracting}
                    />
                  </h3>
                  {errMsg && (
                    <Typography color="error"
                      variant="caption"
                      sx={{
                        mt: 0.5, display: 'block', opacity: 1, height: 'auto',
                        overflow: 'hidden', transition: 'opacity 0.2s ease-in-out, height 0.2s ease-in-out',

                      }}>{errMsg}
                    </Typography>)}

                </div>
              </li>

              {waypoints.map((waypoint, index) => (
                <li className="c-stepper__item2" key={index}>
                  <div className="c-stepper__content">
                    <h3 className="c-stepper__title">
                      <Box sx={{ marginLeft: 4 }}>
                        {" "}
                        {/* Adjust this value as needed */}
                        <Grid container sx={{ marginTop: 1 }}>
                          <Grid item xs={10} sm={10} md={10} gap={0}>
                            <MaterialAuto
                              type="waydrop"
                              waydrop={waypoints[index]}
                              waydropIndex={index}
                              setWaydrop={(i, value) => {
                                const updated = [...waypoints];
                                updated[i] = value;
                                setWaypoints(updated);
                              }}
                              setUserInteracting={setUserInteracting}
                              value={{ description: waypoint.address }}
                              onChange={(val) =>
                                handleWaypointChange(index, val)
                              }
                            />
                          </Grid>
                          <Grid

                          >
                            <CancelIcon
                              onClick={() => handleRemoveDrop(index)}
                              style={{ cursor: "pointer", color: "black", marginLeft: "10px", marginTop: "5px" }}
                            />
                          </Grid>
                        </Grid>
                      </Box>
                    </h3>
                  </div>
                </li>
              ))}

              <li
                className="c-stepper__item1"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className="c-stepper__content">
                  <h3 className="c-stepper__title">
                    <MaterialAuto
                      type="drop"
                      drop={drop}
                      pickup={pickup}
                      setPath={setPath}
                      setPickup={setPickup}
                      setDrop={setDrop}
                      setUserInteracting={setUserInteracting}
                    />
                  </h3>
                  {dropErrMsg && (
                    <Typography color="error"
                      variant="caption"
                      sx={{
                        mt: 0.5, display: 'block', opacity: 1, height: 'auto',
                        overflow: 'hidden', transition: 'opacity 0.2s ease-in-out, height 0.2s ease-in-out',

                      }}>{dropErrMsg}
                    </Typography>)}

                </div>

                {/* Add Drop Icon (Inline) */}

              </li>
            </ol>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const TwoWayAddressSearchBar = ({ setDateValue }) => {
    const [twoWaydrop, setTwoWaydrop] = useState([]);

    const handleAddDrop = () => {
      const newPoint = { location: {} };
      setTwoWaypoints([...twoWaypoints, newPoint]);
      setTwoWaydrop([...twoWaypoints, newPoint]);
    };

    const handleRemoveDrop = (index) => {
      const updatedWayPath = [...wayPath];
      updatedWayPath.splice(index, 1);
      setTwoWayPath(updatedWayPath);

      const updatedWaypoints = [...twoWaypoints];
      updatedWaypoints.splice(index, 1);
      setTwoWaypoints(updatedWaypoints);
      setTwoWaydrop(updatedWaypoints);
    };

    return (
      <Box sx={{ marginTop: "8px", backgroundColor: "#f9fafb" }}>
        <Grid container spacing={0} alignItems="center">
          <Grid item xs={4} className={classes.formContent}>
            <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
              Two Way Pickup & Drop
            </Typography>
          </Grid>

          <Grid item xs={8} className={classes.formContent}>
            <ol className="c-stepper" style={{ padding: 0 }}>
              {/* Pickup Location */}
              <li className="c-stepper__item">
                <div className="c-stepper__content">
                  <h3 className="c-stepper__title">
                    <MaterialAuto1
                      className="pickup1"
                      type="pickup"
                      drop1={drop1}
                      pickup1={drop}
                      setPickup1={setPickup1}
                      setPath1={setPath1}
                      setDrop1={setDrop1}
                      setUserInteracting={setUserInteracting}
                      disabled={true}
                    />
                  </h3>
                </div>
              </li>

              {twoWaypoints.map((waypoint, index) => (
                <li className="c-stepper__item2" key={index}>
                  <div className="c-stepper__content">
                    <h3 className="c-stepper__title">
                      <Box sx={{ marginLeft: 4 }}>
                        <React.Fragment key={index}>
                          <Grid container sx={{ marginTop: 1 }}>
                            <Grid item xs={10} sm={10} md={10}>
                              <MaterialAuto1
                                key={index}
                                type="waydrop"
                                waydrop1={twoWaypoints[index]}
                                waydropIndex1={index}
                                setWaydrop1={(i, value) => {
                                  const updated = [...twoWaypoints];
                                  updated[i] = value;
                                  setTwoWaypoints(updated);
                                }}
                                setUserInteracting={setUserInteracting}
                                value={{ description: waypoint.address }}
                                onChange={(val) =>
                                  handleWaypointChange(index, val)
                                }
                              />
                            </Grid>
                            <Grid

                            >
                              <CancelIcon
                                onClick={() => handleRemoveDrop(index)}
                                style={{ cursor: "pointer", color: "black", marginLeft: "10px", marginTop: "5px" }}
                              />
                            </Grid>
                          </Grid>
                        </React.Fragment>
                      </Box>
                    </h3>
                  </div>
                </li>
              ))}

              <li
                className="c-stepper__item1"
                style={{ display: "flex", alignItems: "center" }}
              >
                <div className="c-stepper__content">
                  <h3 className="c-stepper__title">
                    <MaterialAuto1
                      type="drop"
                      drop1={drop1}
                      pickup1={pickup1}
                      setPath1={setPath1}
                      setPickup1={setPickup1}
                      setDrop1={setDrop1}
                      setUserInteracting={setUserInteracting}
                    />
                  </h3>
                </div>

                {/* Add Drop Icon (Inline) */}

              </li>
            </ol>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const SubscriptionPlanPicker = ({
    selectedPlan,
    subscriptionPlan,
    activeIndexSub,
    setActiveIndexSub,
  }) => {

    const cardRefs = useRef([]);



    if (subscriptionPlan.length > 0 && !defaultPlanSet.current) {
      const storedPlan = sessionStorage.getItem("subscriptionInfo");
      const initialPlan = storedPlan
        ? JSON.parse(storedPlan)
        : subscriptionPlan[0];

      setSelectedPlan(initialPlan);
      setActiveIndexSub(
        subscriptionPlan.findIndex((plan) => plan._id === initialPlan._id)
      );
      sessionStorage.setItem("subscriptionInfo", JSON.stringify(initialPlan));

      defaultPlanSet.current = true;
    }





    const handleCardClick = useCallback((index, plan) => {
      if (!plan) return;

      setActiveIndexSub(index);

      setEndDate(null);
      setStartDate(null);

      setSelectedPlan(plan);

      sessionStorage.setItem("subscriptionInfo", JSON.stringify(plan));
    }, []);


    useEffect(() => {
      // Check if the ref for the active card exists
      if (cardRefs.current[activeIndexSub]) {
        // Use scrollIntoView to bring the card into sight
        cardRefs.current[activeIndexSub].scrollIntoView({
          behavior: "auto",
          inline: "nearest",
          block: "nearest",
        });
      }
    }, [activeIndexSub]);

    // console.log("activeIndexSub", activeIndexSub);


    return (
      <>
        <Box sx={{ flexGrow: 1, mt: 2 }}>
          <Grid container spacing={1} alignItems="center">
            <Grid item xs={4}>
              <Typography
                style={{ fontSize: "14px", fontWeight: "400", }}>
                Subscription Plan
              </Typography>
            </Grid>

            <Grid container item xs={8} flexDirection="row">
              <Box

                style={{
                  display: "flex",
                  overflowX: "auto",
                  gap: "10px",
                  padding: "10px",
                }}
              >
                {subscriptionPlan.length !== 0 ? (
                  subscriptionPlan.map((plan, index) => (
                    <Card
                      key={index}
                      ref={el => (cardRefs.current[index] = el)}
                      className={
                        activeIndexSub === index
                          ? classes.activePlan
                          : classes.cardSubscription
                      }
                      onClick={() => handleCardClick(index, plan)}
                      style={{
                        cursor: "pointer",
                        padding: "10px",
                        minWidth: "150px",
                      }}
                    >
                      <Typography
                        variant="subtitle2"
                        style={{ fontSize: "12px", fontWeight: "bold" }}
                      >
                        {plan.planName}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        style={{
                          fontSize: "12px",
                          fontWeight: "bold",
                        }}
                      >
                        {plan.tripTypeLabel}
                      </Typography>
                      <Typography
                        variant="subtitle2"
                        style={{ fontSize: "14px", fontWeight: "400" }}
                      >
                        {plan.typeLabel}
                      </Typography>
                    </Card>
                  ))
                ) : (
                  <Typography variant="subtitle2" style={{ color: "#ff0000" }}>
                    No Plans Available
                  </Typography>
                )}
              </Box>
            </Grid>
          </Grid>
        </Box>
      </>
    );
  };




  const SchedulePickerOld = () => {
    const handleChange = (event) => {
      let bookNow = event.target.value;
      if (bookNow == "Now") {
        setBookNow(true);
        setDateValue(null);
      } else {
        setBookNow(false);
        let date = new Date(new Date().setMinutes(new Date().getMinutes() + 5));
        setTimeVaule(date);
        setDateValue(moment(date).format("YYYY-MM-DD hh:mm:ss A"));
      }
    };

    const [timeVaule, setTimeVaule] = React.useState(
      new Date(new Date().setHours(new Date().getHours() + 1))
    );

    let currentDateUTC = new Date();
    let currentDateCalFormat =
      currentDateUTC.getFullYear() +
      "-" +
      (currentDateUTC.getMonth() + 1) +
      "-" +
      currentDateUTC.getDate();

    const [pickerView, setPickerView] = useState("day"); // Track picker state

    const handleDateChange = (newValue) => {
      if (!newValue) return;

      if (pickerView === "day") {
        setPickerView("hours"); // Move to hours selection
      } else if (pickerView === "hours") {
        setPickerView("minutes"); // Move to minutes selection
      } else {
        setDateValue(moment(newValue).format("YYYY-MM-DD HH:mm:ss")); // Set final value
        setPickerView("day"); // Reset for next use
      }
    };

    let currentTimeCalFormat =
      currentDateCalFormat + " " + currentDateUTC.getMinutes() + ":00";

    return (
      <Box style={{ flexGrow: 1, marginTop: "25px" }}>
        <Grid container spacing={0} flexDirection="row" alignItems="center">
          <Grid item xs={4} className={classes.formContent}>
            <Box>
              {" "}
              <Typography
                style={{ fontSize: "14px", fontWeight: "400" }}
                variaint="subtitle2"
              >
                Pickup Time:
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={8} className={classes.formContent}>
            <Box style={{ display: 'flex', flexDirection: 'column', gap: "8px" }}>
              <Box
                style={{
                  // padding: "10px",
                  // marginLeft: "50px",
                  display: 'flex',
                  flexDirection: 'row',
                  alignItems: 'center'
                  // justifyContent: "start",
                }}
              >
                <div onChange={handleChange}>
                  <div className="sound-signal">
                    {/* <input
                type="radio"
                value="Now"
                name="booknow"
                id="soundsignal1"
                checked={bookNow}
              />
              <label for="soundsignal1" style={{ marginRight: "12px" }}>
                Now
              </label> */}
                    <input
                      type="radio"
                      value="Later"
                      name="booknow"
                      id="soundsignal2"
                      checked={!bookNow}
                    />
                    <label for="soundsignal2">Schedule</label>
                  </div>
                </div>
              </Box>


              {!bookNow ? (
                <Box
                  style={{
                    // marginTop: "16px",
                    // marginBottom: "16px",
                    marginRight: '15px',

                    // margin:"50px",

                    display: 'flex',
                    flexDirection: 'row',
                    justifyContent: 'space-between'
                  }}
                >
                  <Box
                    style={{
                      marginTop: '5px',
                      marginLeft: '5px',
                      // width:"140px",

                      marginRight: '20px'
                    }}
                  >
                    <CustomDateTimePicker bufferingTime={laterTime?.laterTime} value={dateValue} setDateValue={setDateValue} minDateTime={new Date(Date.now() + (laterTime?.laterTime - 1) * 60 * 1000)} />
                    {/* <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DateTimePicker
                        renderInput={(params) => (
                          <TextFieldMui
                            id="outlined-select-currency-native"
                            size="small"
                            {...params}
                            error={false}
                          />
                        )}
                        label="Pickup time"
                        inputFormat="dd/MM/yyyy hh:mm a"
                        value={dateValue}
                        autoOk
                        onClose={() => {
                        }}
                        onAccept={(newValue) => {
                          setDateValue(
                            moment(newValue).format("YYYY-MM-DD hh:mm:ss A")
                          );
                        }}
                        clearable
                        onChange={(newValue) => {

                        }}
                        // minDateTime={
                        //   new Date(new Date().getTime() + 60 * 60 * 1000) // Current time plus one hour
                        // }
                        minDateTime={new Date(Date.now() + (laterTime?.laterTime - 1) * 60 * 1000)}
                        inputProps={{
                          min: currentTimeCalFormat,
                        }}
                      />
                    </LocalizationProvider> */}
                  </Box>
                </Box>
              ) : (
                ''
              )}
            </Box>
          </Grid>
        </Grid>
      </Box>
    );
  };

  const SchedulePicker = React.memo(
    ({
      startDate,
      setStartDate,
      endDate,
      setEndDate,
      time,
      selectedModel,
      setTime,
      baseFare,
      setBaseFare,
      pickUp,
      drop,
      isHourlyPlan,
      setIsHourlyPlan,
      selectedDays,
      setSelectedDays,
      selectedPlan,
      selectedHourlyTime,
      setSelectedHourlyTime,
      subscriptionTripFare,
      setSubscriptionTripFare,
      twoWayPickupTime,
      setTwoWayPickupTime,
      totalDaysCount,
      setTotalDaysCount,
      setPickupTimeSlot,
      setDropTimeSlot,
      pickUp1,
      drop1,
      twoWayTripFare,
      setTwoWayTripFare, setDayTimeState, dayTimeState,
      setIsRecurringBooking,
      recurringBookingEnable,
      setRecurringBookingEnable,
      path,
      path1
    }) => {
      const [view, setView] = useState("hours");
      const [selectedHour, setSelectedHour] = useState(null);
      // const [tempSelectedDays, setTempSelectedDays] = useState(selectedDays);

      const [open, setOpen] = useState(false);
      const [planStartDate, setPlanStartDate] = useState(null);
      const [planEndDateNew, setPlanEndDateNew] = useState(null);
      const [tempSelectedDays, setTempSelectedDays] = useState([]);




      useEffect(() => {
        if (isRecurringBooking) {
          setRecurringBookingEnable((prev) => prev || 1);
        }
      }, [setRecurringBookingEnable]);

      useEffect(() => {
        if (selectedPlan) {


          setPlanEndDateNew(
            moment(selectedPlan?.endDateTime).format("YYYY-MM-DD")
          );

          setPlanStartDate(
            moment(selectedPlan?.fromDateTime).format("YYYY-MM-DD")
          );

          if (!startDate || !endDate) {
            const currentDate = moment().format("YYYY-MM-DD");
            let planStartDate = currentDate;

            if (selectedPlan?.fromDateTime) {
              const selectedFromDate = moment(
                selectedPlan?.fromDateTime
              ).format("YYYY-MM-DD");

              if (currentDate > selectedFromDate) {
                planStartDate = currentDate;
              } else {
                planStartDate = selectedFromDate;
              }
            }

            setStartDate(planStartDate);

            let planEndDate;

            if (selectedPlan?.type === 1) {
              // Weekly: Add 1 week, but not beyond selectedPlan.endDateTime
              const nextWeek = moment().add(1, "week");
              const planEnd = moment(selectedPlan?.endDateTime);
              planEndDate = nextWeek.isAfter(planEnd)
                ? planEnd.format("YYYY-MM-DD")
                : nextWeek.format("YYYY-MM-DD");
            } else if (selectedPlan?.type === 2) {
              // Monthly: Add 1 month, but not beyond selectedPlan.endDateTime
              const nextMonth = moment().add(1, "month");
              const planEnd = moment(selectedPlan?.endDateTime);
              planEndDate = nextMonth.isAfter(planEnd)
                ? planEnd.format("YYYY-MM-DD")
                : nextMonth.format("YYYY-MM-DD");
            } else {
              // Hourly: Just set the end date as is
              planEndDate = moment(selectedPlan.endDateTime).format(
                "YYYY-MM-DD"
              );
            }

            setEndDate(planEndDate);
          }


          setIsRecurringBooking(selectedPlan?.isRecurringBooking === 1);

        }
      }, [
        selectedPlan,
        endDate,
        setIsHourlyPlan,
        setStartDate,
        setEndDate,
        startDate,
        setIsRecurringBooking
      ]);


      useEffect(() => {
        if (view === "hours" && selectedHour !== null) {
          setTimeout(() => setView("minutes"), 10000); // ✅ Delay ensures proper transition
        }
      }, [selectedHour]);

      useEffect(() => {
        if (startDate && endDate && planBaseFare && planBaseFare !== "") {
          let count = 0;
          let firstWeekCount = 0;

          let currentDate = moment(startDate).startOf("day");
          const end = moment(endDate).startOf("day");

          const firstWeekEnd = moment(startDate).clone().add(6, 'days').startOf("day");

          // console.log("selectedDays",selectedDays);

          while (currentDate.isSameOrBefore(end)) {
            const dayOfWeek = currentDate.weekday(); // 0 (Sun) - 6 (Sat)

            if (selectedDays.includes(dayOfWeek)) {
              count++;

              if (currentDate.isSameOrBefore(firstWeekEnd)) {
                firstWeekCount++;
              }
            }

            currentDate.add(1, "day");
          }

          const start = moment(startDate).startOf("day");
          const totalDays = end.diff(start, 'days') + 1;

          // console.log("count", count);


          setTotalDaysCount(count);
          setFirstWeekDaysCount(firstWeekCount);
          setInBetweenDaysCount(totalDays);

          // const calculatedFare = count * planBaseFare;
          // const twoWayFare = count * twoWayBaseFare;

          let calculatedFare;
          let twoWayFare;


          if (selectedPlan.tripType === 2) {
            calculatedFare = planBaseFare / ( count * 2) ;
          } else {
            calculatedFare = planBaseFare / count;
          }

          if (selectedPlan.tripType === 2) {
            twoWayFare = twoWayBaseFare / (count * 2);
          } else {
            twoWayFare = twoWayBaseFare / count;
          }


          setSubscriptionTripFare(parseFloat(calculatedFare.toFixed(2)));

          if (selectedPlan.tripType === 2) {
            setTwoWayTripFare(parseFloat(twoWayFare.toFixed(2)));
          }
        }
      }, [startDate, endDate, planBaseFare, selectedDays, twoWayBaseFare]);






      const handleEndDateChange = (newValue) => {
        // console.log("planEndDateNew->", planEndDateNew);
        // console.log("new end date->", newValue);

        if (newValue) {
          const formattedDate = moment(newValue).format("YYYY-MM-DD");

          if (
            moment(formattedDate).isAfter(moment(startDate), "day") &&
            moment(formattedDate).isSameOrBefore(moment(planEndDateNew), "day")
          ) {
            // console.log("formattedDate->", formattedDate);

            setEndDate(formattedDate);
          } else {
            alert(
              `End Date must be between ${moment(startDate).format(
                "DD/MM/YYYY"
              )} and ${moment(planEndDateNew).format("DD/MM/YYYY")}`
            );
          }
        }
      };

      const handleStartDateChange = (newValue) => {
        if (newValue) {
          const selectedDate = moment(newValue).format("YYYY-MM-DD");

          // Ensure start date is not greater than end date
          if (moment(selectedDate).isAfter(moment(endDate))) {
            alert("Start date cannot be greater than the end date!");
            return;
          }

          // Ensure start date is not less than planStartDate
          if (moment(selectedDate).isBefore(moment(planStartDate))) {
            alert("Start date cannot be before the plan start date!");
            return;
          }

          // console.log("New Start Date Value -->", selectedDate);
          setStartDate(selectedDate);
        }
      };

      const daySlot = [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ];

      useEffect(() => {
        // Sync rawSelectedDays when selectedDays change
        const selectedDayNames = selectedDays.map((index) => daySlot[index]);
        setTempSelectedDays(selectedDays);
        setRawSelectedDays(selectedDayNames);
      }, [selectedDays]);

      const [rawSelectedDays, setRawSelectedDays] = useState([]); // string[] like ["Monday", "Tuesday"]

      const handleDayChange = (event) => {
        const { value } = event.target;

        if (value.includes("All")) {
          setRawSelectedDays(
            rawSelectedDays.length === 7 ? [] : daySlot.slice(1) // ["Sunday", ..., "Saturday"]
          );
        } else {
          setRawSelectedDays(value);
        }
      };

      const handleClose = () => {
        const indexes = rawSelectedDays.map((day) => daySlot.indexOf(day)); // convert to 0–6
        setTempSelectedDays(indexes);
        setSelectedDays(indexes);


        setPickupErrMsg("");

        setDayTimeState((prevState) => {
          let newState = {};

          // keep only selected days
          indexes.forEach((i) => {
            const name = daySlot[i];
            newState[name] = prevState[name] || {
              pickup: "00:00",
              ...(selectedPlan?.tripType === 2 ? { drop: "00:00" } : {}),
            };
          });

          sessionStorage.setItem("dayTimeState", JSON.stringify(newState));
          return newState;
        });


        setOpen(false);
      };





      // useEffect(() => {
      //   console.log("recurringBookingEnable", recurringBookingEnable);
      //   console.log("isRecurringBooking", isRecurringBooking);
      // }, [recurringBookingEnable, isRecurringBooking]);


      // console.log("end date" ,endDate);
      // console.log("selectedHourlyTime", selectedHourlyTime);

      // console.log("recurringBookingEnable", recurringBookingEnable);


      return (
        <>
          {selectedPlan?.tripType === 2 && <TwoWayAddressSearchBar />}

          <Box style={{ flexGrow: 1, marginTop: "25px" }}>
            <Grid container spacing={1} flexDirection="row" alignItems="center">
              <Grid item xs={4}>
                <Typography style={{ fontSize: "14px", fontWeight: "400" }}>
                  Day Slot
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <FormControl style={{ width: "100%" }}>

                  <Select
                    multiple
                    open={open}
                    onOpen={() => setOpen(true)}
                    onClose={handleClose}
                    value={rawSelectedDays}
                    onChange={handleDayChange}
                    input={<OutlinedInput />}
                    renderValue={(selected) => selected.join(', ')}
                    MenuProps={{
                      PaperProps: {
                        style: {
                          maxHeight: 224,
                          overflowY: "auto",
                        },
                      },
                      anchorOrigin: {
                        vertical: "bottom",
                        horizontal: "left",
                      },
                      transformOrigin: {
                        vertical: "top",
                        horizontal: "left",
                      },
                      getContentAnchorEl: null,
                    }}
                  >
                    {daySlot.map((day, index) => (
                      <MenuItem
                        key={day}
                        value={day}
                        onClick={(e) => e.stopPropagation()}
                      >
                        <Checkbox
                          color={companyTheme?.primaryColorCode}
                          checked={
                            day === "All"
                              ? rawSelectedDays.length === 7
                              : rawSelectedDays.includes(day)
                          }
                        />
                        <ListItemText primary={day} />
                      </MenuItem>
                    ))}
                  </Select>

                </FormControl>
              </Grid>
            </Grid>
          </Box>

          {isHourlyPlan ? (
            <Box style={{ flexGrow: 1, marginTop: "20px" }}>
              <Grid
                container
                spacing={1}
                flexDirection="row"
                alignItems="center"
              >
                <Grid item xs={4}>
                  <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
                    Hours
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <FormControl style={{ width: "100%" }}>
                    <Select
                      value={selectedHourlyTime || ""}
                      onChange={(e) => {
                        setSelectedHourlyTime(e.target.value);
                      }}
                      input={<OutlinedInput />}
                    >
                      {Array.from(
                        { length: selectedPlan?.hours || 0 },
                        (_, i) => i + 1
                      ).map((num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      ))}
                    </Select>
                  </FormControl>
                </Grid>
              </Grid>
            </Box>
          ) : null}

          {isRecurringBooking ? (
            <Box style={{ flexGrow: 1, marginTop: "20px" }}>
              <Grid container spacing={1} flexDirection="row" alignItems="center">
                <Grid item xs={4}>
                  <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
                    Recurring Booking
                  </Typography>
                </Grid>
                <Grid item xs={8}>
                  <Checkbox
                    color={companyTheme?.primaryColorCode}
                    checked={recurringBookingEnable === 1}
                    onChange={(e) =>
                      setRecurringBookingEnable(e.target.checked ? 1 : 2)
                    }
                  />
                </Grid>
              </Grid>
            </Box>
          ) : null}


          {/* Pickup Time */}
          {tempSelectedDays && tempSelectedDays.length !== 0 && (
            <CustomerTimePicker
              tempSelectedDays={tempSelectedDays}
              daySlot={daySlot}
              selectedPlan={selectedPlan}
              dayTimeState={dayTimeState}
              setDayTimeState={setDayTimeState}
            />
          )}

          <Box style={{ flexGrow: 1, marginTop: "8px" }}>
            <Grid
              container
              spacing={1}
              flexDirection="column"
              alignItems="center"
            >
              <Grid item xs={4}>
                <Typography style={{ fontSize: "14px", fontWeight: "400", }}>

                </Typography>
              </Grid>

              {pickupErrMsg && (
                <Typography color="error"
                  variant="caption"
                  sx={{
                    mt: 0.5, display: 'block', opacity: 1, height: 'auto',
                    overflow: 'hidden', transition: 'opacity 0.2s ease-in-out, height 0.2s ease-in-out',

                  }}>
                  {pickupErrMsg}
                </Typography>)}

            </Grid>
          </Box>

          {/* Start Date */}
          <Box style={{ flexGrow: 1, marginTop: "8px" }}>
            <Grid
              container
              spacing={1}
              flexDirection="column"
              alignItems="center"
            >
              <Grid item xs={4}>
                <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
                  Start Date
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Box style={{ display: "flex" }}>
                  <Box style={{ marginRight: "15px" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="Start Date"
                        inputFormat="dd/MM/yyyy"
                        value={
                          startDate ? moment(startDate, "YYYY-MM-DD") : null
                        }
                        onChange={handleStartDateChange}
                        renderInput={(params) => (
                          <TextField size="small" {...params} error={false} />
                        )}
                        disablePast
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
              </Grid>

              {/* End Date */}
              <Grid item xs={4}>
                <Typography style={{ fontSize: "14px", fontWeight: "400", }}>
                  End Date
                </Typography>
              </Grid>
              <Grid item xs={8}>
                <Box style={{ display: "flex" }}>
                  <Box style={{ marginRight: "15px" }}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                      <DatePicker
                        label="End Date"
                        inputFormat="dd/MM/yyyy"
                        value={endDate || null}
                        onChange={handleEndDateChange}
                        renderInput={(params) => (
                          <TextField
                            id="outlined-select-currency-native"
                            size="small"
                            {...params}
                            error={false}
                          />
                        )}
                        minDate={moment(startDate)}
                        maxDate={
                          planEndDateNew
                            ? moment(planEndDateNew).toDate()
                            : undefined
                        }
                      />
                    </LocalizationProvider>
                  </Box>
                </Box>
              </Grid>
            </Grid>
          </Box>

          {/* {subscriptionTripFare !== null &&
            subscriptionTripFare !== undefined &&
            selectedDays.length !== 0 &&
            !isNaN(subscriptionTripFare) && (
              <Box style={{ flexGrow: 1, marginTop: "8px" }}>
                <Grid
                  container
                  spacing={1}
                  flexDirection="row"
                  alignItems="center"
                >
                  <Grid item xs={4}>
                    <Typography style={{ fontSize: "14px", fontWeight: "400" }}>
                      One Way Trip Fare
                    </Typography>
                  </Grid>

                  <Grid item xs={8}>
                    <Box style={{ marginRight: 15 }}>
                      <Typography style={{ fontSize: 14, fontWeight: 400 }}>
                        {subscriptionTripFare > 0
                          ? `${subscriptionTripFare} AED`
                          : "-"}{" "}
                        ({totalDaysCount + " Days"})
                      </Typography>
                    </Box>
                  </Grid>

                  {selectedPlan.tripType === 2 &&
                    pickUp1.coords.lat() !== 0 &&
                    pickUp1.coords.lng() !== 0 &&
                    drop1.coords.lat() !== 0 &&
                    drop1.coords.lng() !== 0 && (
                      <>
                        <Grid item xs={4}>
                          <Typography
                            style={{ fontSize: "14px", fontWeight: "400" }}
                          >
                            Two Way Trip Fare
                          </Typography>
                        </Grid>

                        <Grid item xs={8}>
                          <Box style={{ marginRight: 15 }}>
                            <Typography
                              style={{ fontSize: 14, fontWeight: 400 }}
                            >
                              {twoWayTripFare > 0
                                ? `${twoWayTripFare} AED`
                                : "-"}{" "}
                              ({totalDaysCount + " Days"})
                            </Typography>
                          </Box>
                        </Grid>
                      </>
                    )}
                </Grid>
              </Box>
            )} */}
        </>
      );
    }
  );


  const [modelCat, setModelCat] = React.useState(TaxiModelArray[0].toString());

  useEffect(() => {
    if (bookType !== 3) {
      sessionStorage.removeItem("subscriptionInfo");
    }
  }, []);

  const defaultPlanSet = useRef(false);

  // console.log("companyId", companyId);


  useEffect(() => {
    const fetchPlans = async () => {
      if (!companyId) return;

      try {
        const response = await axios.get(
          `${BACKEND_URL}/listActivePlanWithFares?fromWebBooker=1`,
          {
            headers: {
              Authorization: `Bearer ${ANON_KEY}`,

            }
          }
        );

        if (response?.data?.status === 1) {
          const plans = response?.data?.responseData?.subscriptions || [];
          setSubscriptionPlan(plans);
          setDefaultPassengerId(response?.data?.passengerId || null);

        } else {
          setDefaultPassengerId(null);
          setSubscriptionPlan([]);
        }
      } catch (error) {
        setDefaultPassengerId(null);
        setSubscriptionPlan([]);
      }
    };

    fetchPlans();
  }, [companyId]);


  useEffect(async () => {

    if (!selectedPlan?._id) return;
    if (selectedPlan?._id && pickup.address !== '' && bookType === 3) {

      try {

        const obj = {
          "subscription_id": selectedPlan?._id,
          "pickup_lat": pickup.coords.lat(),
          "pickup_lng": pickup.coords.lng(),
          "model_id": selectedModel?._id,
          ...(drop.address !== ""
            ? {
              "isDrop": 1,
              "drop_lat": drop.coords.lat(),
              "drop_lng": drop.coords.lng()

            }
            : {}),
        }

        const response = await axios.post(
          `${BACKEND_URL}/validatePickupInsideSubscriptionZones?fromWebBooker=1`,
          obj,
          {
            headers: {
              Authorization: `Bearer ${ANON_KEY}`,

            }
          }
        );

        if (response?.data?.status === 1) {
          // console.log("resss", response);
          setIsValidPlan(true);


          if (drop.address !== '') {
            setDropErrMsg(null)
          } else {
            setErrMsg(null);
          }


        } else {
          // console.log("resss", response);
          setIsValidPlan(false);


          if (drop.address !== '') {
            setDropErrMsg(response?.data?.message)
          } else {
            setErrMsg(response?.data?.message);
          }



          // alert(response?.data?.message);

        }
      } catch (error) {
        console.error("Error validating subscription plan:", error);

      }
    }

  }, [selectedPlan, pickup.address, selectedModel, drop.address]);


  const [openAdd3, setOpenAdd3] = React.useState(false);
  const [alertMsg, setAlertMsg] = React.useState("Something went wrong");
  const [pickupErrMsg, setPickupErrMsg] = React.useState("");
  const [errMsg, setErrMsg] = React.useState(null);
  const [dropErrMsg, setDropErrMsg] = React.useState(null);
  const [openAdd3Success, setOpenAdd3Success] = React.useState(false);

  useEffect(() => {
    // console.log("showErrorMessage", showErrorMessage);

    // Remove the old value before saving the new one
    sessionStorage.removeItem("showErrorMessage");

    if (showErrorMessage) {
      sessionStorage.setItem(
        "showErrorMessage",
        JSON.stringify(showErrorMessage)
      );
    }

    if (showErrorMessage?.status === 1) {
      navigate("/bookingconfirmation");
    } else if (showErrorMessage?.status === -1) {
      setAlertMsg(showErrorMessage?.message);
      setOpenAdd3(true);
    }
  }, [showErrorMessage]);

  const handleAddClose3 = () => {
    setOpenAdd3(false);
    // setOpenOtp(true);
  };

  const [val, setVal] = useState("");

  const [loader1, setLoader1] = useState(false);
  const [loader2, setLoader2] = useState(false);
  const [loader3, setLoader3] = useState(false);
  const [openOtp, setOpenOtp] = React.useState(false);
  const [countDown, setCountDown] = useState(null);
  const [newUser, setNewUser] = useState(null);

  const [openAdd4, setOpenAdd4] = React.useState(false);

  // const [waypoints, setWaypoints] = useState([]);
  const [twoWaypoints, setTwoWaypoints] = useState([]);

  const [wayPath, setWayPath] = useState([]);
  const [twoWayPath, setTwoWayPath] = useState([]);

  const handleCloseOtp = () => {
    setOpenOtp(false);
  };



  const handleChangeValidate = (e) => {
    sessionStorage.removeItem("otp");

    const regex = /^[0-9\b]+$/;
    if (e.target.value === "" || regex.test(e.target.value)) {
      setVal(e.target.value);
    }
    sessionStorage.setItem("otp", e.target.value);
  };


  var subscriptionDetails = sessionStorage.getItem("subscriptionInfo");
  var subscriptionDetailsNew = JSON.parse(subscriptionDetails);
  var passengerId = JSON.parse(sessionStorage?.getItem('passengerId'));
  var otp = sessionStorage.getItem("otp");

  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const ResendOtp = () => {
    let obj;

    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    if (bookType === 3) {
      obj = {
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        subscription: 1, // Only included if bookType is 3
        email: a.email
      };
    } else {
      obj = {
        countryCode: `+${a.countryCode}`,
        phone: a.mobileNumber,
        companyId: companyId,
        type: 2,
        email: a.email
      };
    }

    setLoader2(true);

    axios
      .post(
        `${BACKEND_URL}/passengerVerifyPhoneWeb?fromWebBooker=1`,
        obj,
        {
          headers: { Authorization: `Bearer ${ANON_KEY}` }
        }

      )
      .then((Response) => {
        if (Response.data.status === 1) {
          setCountDown(30);
          setNewUser(Response.data.newUser);
          const obj2 = {
            passengerId: Response?.data?.responsData?._id,
          };

          sessionStorage.setItem("passengerId", JSON.stringify(obj2));
        } else if (Response.data.status === -1) {

          setCountDown(null);
          setAlertMsg(Response.data.message);
          setOpenAdd4(true);
        } else {
          setCountDown(null);

          setAlertMsg("Something went wrong");
          setOpenAdd3(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  function getPassengerUpdate(trip_id) {

    setsearchingDriver(true);
    const postData = {
      passenger_tripid: trip_id,
      request_type: "1",
      drop_lat: 0,
      drop_long: 0,
      cancel_type: "0",
      passenger_id: "330",
    };
    axios
      .post(
        "https://fride.limor.us/passengerapi111/index/?encode=regina.taximobility.c" +
        "om-1636796261&type=getdriver_update&lang=en",
        postData,
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: "authkey ${authkey}",
          },
        }
      )
      .then((Response) => {
        if (Response.data.status == 1) {
          ;
          setTripID(trip_id);
          setsearchingDriver(false);
        } else {
          setsearchingDriver(false);
          setshowErrorMessage(Response.data.message);
        }
      })
      .catch((error) => {
        console.log("error Comes:", error);
      });
  }

  function BookTaxi(address) {
    const items = JSON.parse(sessionStorage.getItem("newUser"));

    var guetsDetailsLocal = sessionStorage.getItem("guestFinal");
    var guetsDetailsLocalNew = JSON.parse(guetsDetailsLocal);
    var a = guetsDetailsLocalNew;

    // setOpenOtp(false);

    if (bookType === 3) {
      const formattedStartDate = moment(startDate, "YYYY-MM-DD HH:mm:ss")
        .startOf("day") // Sets time to 00:00:00
        .format("YYYY-MM-DD HH:mm:ss");

      const formattedEndDate = moment(endDate, "YYYY-MM-DD HH:mm:ss")
        .endOf("day") // Sets time to 23:59:59
        .format("YYYY-MM-DD HH:mm:ss");

      const formattedPickupTime = moment(time, ["h:mm A"]).format("HH:mm:ss");
      const formattedTwoWayPickupTime = moment(twoWayPickupTime, [
        "h:mm A",
      ]).format("HH:mm:ss");





      const dayMap = {
        Sunday: 0,
        Monday: 1,
        Tuesday: 2,
        Wednesday: 3,
        Thursday: 4,
        Friday: 5,
        Saturday: 6,
      };

      const oneWayPickupTimeSlot = [];
      const twoWayPickupTimeSlot = [];

      const storedData = sessionStorage.getItem("dayTimeState");

      const dayTime = JSON.parse(storedData);

      Object.entries(dayTime).forEach(([day, times]) => {
        if (times.pickup) {
          oneWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.pickup}:00`,
          });
        }
        if (times.drop) {
          twoWayPickupTimeSlot.push({
            slot: dayMap[day],
            pickupTime: `${times.drop}:00`,
          });
        }
      });

      let dropLocationInfo;

      if (waypoints.length !== 0) {
        dropLocationInfo = {
          address: [...waypoints.map((w) => w.address), drop.address],
          latitude: [
            ...waypoints.map((w) => w.coords.lat()),
            drop.coords.lat(),
          ],
          longitude: [
            ...waypoints.map((w) => w.coords.lng()),
            drop.coords.lng(),
          ],
        };
      } else {
        dropLocationInfo = {
          address: drop.address,
          latitude: drop.coords.lat(),
          longitude: drop.coords.lng(),
        };
      }

      let twoWayDropLocationInfo;

      if (twoWaypoints.length !== 0) {
        twoWayDropLocationInfo = {
          address: [...twoWaypoints.map((w) => w.address), drop1.address],
          latitude: [
            ...twoWaypoints.map((w) => w.coords.lat()),
            drop1.coords.lat(),
          ],
          longitude: [
            ...twoWaypoints.map((w) => w.coords.lng()),
            drop1.coords.lng(),
          ],
        };
      } else {
        twoWayDropLocationInfo = {
          address: drop1.address,
          latitude: drop1.coords.lat(),
          longitude: drop1.coords.lng(),
        };
      }

      const postData = {
        _id: defaultPassengerId,
        newUser: newUser,
        motorModelId: selectedModel._id,
        otp: otp,
        subscriptionPlanInfo: subscriptionDetailsNew,
        pickupTime: formattedPickupTime,
        // customerName: a.firstName + " " +a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        phoneNumber: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        pickupLocationInfo: {
          address: address,
          latitude: pickup.coords.lat(),
          longitude: pickup.coords.lng(),
        },
        dropLocationInfo,
        approxDistance: distance,
        approxDuration: duration,
        type: subscriptionDetailsNew?.type,
        tripType: subscriptionDetailsNew?.tripType,
        farePerTrip: subscriptionTripFare,
        totalFare: planBaseFare,
        startDateTime: formattedStartDate,
        endDateTime: formattedEndDate,
        daySlot: selectedDays,
        oneWayRoutePolyline,
        hours: selectedHourlyTime,
        isRecurringBooking: isRecurringBooking,
        ...(subscriptionDetailsNew?.tripType === 2 && {
          twoWayPickupTime: formattedTwoWayPickupTime,
          twoWayDropLocationInfo,
          twoWayRoutePolyline,
          twoWayPickupLocationInfo: {
            address: pickup1.address,
            latitude: pickup1.coords.lat(),
            longitude: pickup1.coords.lng(),
          },
          twoWayfarePerTrip: twoWayTripFare,
          twoWaytotalFare: twoWayBaseFare,
          twoWayApproxDistance: distance2,
          twoWayApproxDuration: duration2
        }),

        oneWayPickupTimeSlot,
        twoWayPickupTimeSlot,
      };

      if (!errMsg && !dropErrMsg) {
        axios
          .post(
            `${BACKEND_URL}/createSubscriptionEnquiry?fromWebBooker=1`,

            postData,
            {
              headers: { Authorization: `Bearer ${ANON_KEY}` }
            }
          )
          .then((Response) => {
            if (Response.data.status >= 1) {

              setOpenOtp(false);
              setAlertMsg(Response.data.message);
              setLoader2(false);
              setLoader1(false);

              if (Response.data.status === 1) {

                setLoader1(false);
                const obj2 = {
                  passengerId: Response.data.detail.passengerInfo.id
                };
                sessionStorage.setItem('passengerId', JSON.stringify(obj2));

                setOpenAdd3Success(true);

                setshowErrorMessage(Response.data);
              } else {
                setOpenAdd3(true);
              }

            }
            else {

              setBookType(3);

              setshowErrorMessage(Response.data);

              const obj2 = {
                passengerId: Response.data.detail.passengerInfo.id
              };
              sessionStorage.setItem('passengerId', JSON.stringify(obj2));
              if (Response.data.isVerified) {
                setOpenOtp(false);
              } else {
                setOpenOtp(true);
              }
              setAlertMsg(Response.data.message);
              setLoader2(false);
              setLoader1(false);
            }
          })
          .catch((error) => {
            console.log(error);
          });
      }
    } else {


      const rawEstimatedFare = fareDetails1?.split_up?.flat()?.find(
        (item) => item.key === "estimatedFare"
      )?.value;

      let estimatedFare = '';

      if (rawEstimatedFare) {
        const match = rawEstimatedFare.match(/^([A-Z]+)\s?([\d.]+)$/);
        if (match) {
          const fareCurrency = match[1];
          const fareAmount = match[2];
          estimatedFare = fareAmount;
        }
      }


      const postData = {
        phone: a.mobileNumber,
        countryCode: `+${a.countryCode}`,
        latitude: pickup.coords.lat().toString(),
        longitude: pickup.coords.lng().toString(),
        pickupplace: address,
        dropplace: drop.address,
        drop_latitude: drop.coords.lat().toString(),
        drop_longitude: drop.coords.lng().toString(),
        pickup_time: dateValue
          ? dayjs(dateValue).format("YYYY-MM-DD hh:mm:ss A")
          : moment().format("YYYY-MM-DD hh:mm:ss A"),
        motor_model: selectedModel._id,
        cityname: "",
        distance_away: 0,
        sub_logid: "",
        friend_id2: "0",
        friend_percentage2: "0",
        friend_id3: "0",
        friend_percentage3: "0",
        friend_id4: "0",
        friend_percentage4: "0",
        friend_id1: getUserId(),
        friend_percentage1: "100",
        passenger_payment_option: 1,
        payment_mode: "1",
        approx_distance: distance,
        approx_duration: duration,
        // passenger_id: '56',
        request_type: "1",
        promo_code: "",
        now_after: 1,
        notes: "",
        passenger_app_version: "1",
        pickup_notes: "",
        drop_notes: "",
        drop_makani: "",
        pickup_makani: "",
        is_guest_booking: "0",
        // name: a.firstName + " " + a.lastName,
        firstName: a.firstName,
        lastName: a.lastName,
        email: a.email,
        guestInfo: {
          countryCode: `+${a.countryCode}`,
          email: a.email,
          mobileNumber: a.mobileNumber,
          name: a.firstName + " " + a.lastName,
        },
        scheduleBookType: bookType,

        ...(bookType === 4 && {
          requested_trip_hour: selectedHourlyBookingTime,
          hourly_fare: modelHourlyFare,
          approxTripFare: selectedHourlyBookingTime * modelHourlyFare,

        }),
        ...(bookType !== 4 && {
          approxTripFare: estimatedFare,
        }),
        passenger_cid: companyId,
        companyId: companyId,
        otp: val,
        newUser: items.newUser,
      };

      axios
        .post(
          `${BACKEND_URL}/saveBooking?fromWebBooker=1`,
          postData,
          {
            headers: { Authorization: `Bearer ${ANON_KEY}`, }
          }
        )
        .then((Response) => {
          if (Response.data.status >= 1) {
            setLoader2(false);

            if (dateValue) {
              setshowErrorMessage(Response.data);
              sessionStorage.setItem(
                "passengerInfo",
                JSON.stringify(Response?.data?.detail?.passengerInfo)
              );

              const obj2 = {
                passengerId: Response.data.detail.passengerInfo.id
              };
              sessionStorage.setItem('passengerId', JSON.stringify(obj2));
            } else {
              getPassengerUpdate(Response.data.detail.passenger_tripid);
            }
          }
          else {
            setshowErrorMessage(Response.data);
            setAlertMsg(Response.data.message);
            setLoader2(false);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  }

  const handleAddClose4 = () => {
    setOpenAdd4(false);
  };

  const handleAddClose41 = () => {
    setOpenAdd4(false);
  };

  const handleAddCloseSuccessNew = () => {
    setOpenAdd3Success(false);
    // setOpenOtp(false);
  };

  const handleAddCloseSuccess = () => {
    setOpenAdd3Success(false);
    // window.location.reload();
  };

  // getNearestDriver("0.0","0.0","0.0","0.0");

  // console.log("pickup",pickup);

  return (
    <>
      <Dialog
        open={openAdd3}
        TransitionComponent={Transition}
        keepMounted
        style={{
          position: "absolute",
          zIndex: 2000,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        }}
        maxWidth="xl"
        onClose={handleAddClose3}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ width: "400px" }}>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container spacing={3}>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img
                  src="/static/images/reject.png"
                  alt="Success"
                  width="100"
                />
              </Grid>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <h3 style={{ color: "red" }}>{alertMsg}</h3>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleAddClose3}
            variant="contained"
            color="white"
            style={{
              backgroundColor: companyTheme?.primaryColorCode,
              color: "white",
              borderRadius: "4px",
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAdd3Success}
        TransitionComponent={Transition}
        keepMounted
        style={{
          position: "absolute",
          zIndex: 2000,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        }}
        maxWidth="xl"
        onClose={handleAddCloseSuccess}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ width: "400px" }}>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container spacing={3}>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img
                  src="/static/images/greenTick.png"
                  alt="Success"
                  width="100"
                />
              </Grid>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <h3>{alertMsg}123</h3>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleAddCloseSuccessNew}
            variant="contained"
            color="white"
            style={{
              backgroundColor: companyTheme?.primaryColorCode,
              color: "white",
              borderRadius: "4px",
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openOtp}
        // onClose={handleCloseOtp}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
        style={{ boxShadow: "1px 1px 1px 1px" }}
      >
        <DialogTitle
          id="alert-dialog-title"
          style={{ paddingTop: "6px", paddingRight: "14px" }}
        >
          <Grid
            container
            spacing={3}
            style={{ display: "flex", justifyContent: "space-between" }}
          >
            <Grid item>{"Please, Enter OTP!"}</Grid>
            <Grid item>
              <CloseIcon
                onClick={handleCloseOtp}
                style={{
                  color: "red",
                  border: "1px solid red",
                  cursor: "pointer",
                }}
              />
            </Grid>
          </Grid>
        </DialogTitle>
        <DialogContent>
          <>
            <TextField
              id="outlined-basic"
              label="OTP"
              inputProps={{ maxLength: 4 }}
              style={{ marginTop: "25px" }}
              value={val}
              onChange={handleChangeValidate}
              fullWidth
              variant="outlined"
            />
            <a
              style={{
                fontSize: "13px",
                marginTop: "5px",
                color:
                  countDown !== null && countDown !== 0 ? "#9d9d9d" : "blue",
                pointerEvents:
                  countDown !== null && countDown !== 0 ? "none" : "",
                cursor: countDown !== null && countDown !== 0 ? "" : "pointer",
              }}
              onClick={() => ResendOtp(pickup.address)}
              disabled={countDown !== null && countDown !== 0 ? true : false}
            >
              Resend OTP{" "}
              {countDown !== null && countDown !== 0 ? `(${countDown})` : ""}
            </a>
          </>
        </DialogContent>
        <DialogActions>
          <>
            <Button
              onClick={() => BookTaxi(pickup.address)}
              style={{
                backgroundColor: companyTheme?.primaryColorCode,
                borderRadius: "4px",
                color: "white",
              }}
              disabled={val.length === 4 ? false : true}
              variant="contained"
            >
              {loader2 ? (
                <CircularProgress style={{ width: "30px", height: "30px", color: "white" }} />
              ) : (
                "Verify"
              )}
            </Button>
          </>
        </DialogActions>
      </Dialog>

      <Dialog
        open={openAdd4}
        TransitionComponent={Transition}
        keepMounted
        style={{
          position: "absolute",
          zIndex: 2000,
          top: 0,
          left: 0,
          bottom: 0,
          right: 0,
        }}
        maxWidth="xl"
        onClose={handleAddClose4}
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogContent style={{ width: "400px" }}>
          <DialogContentText id="alert-dialog-slide-description">
            <Grid container spacing={3}>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <img
                  src="/static/images/reject.png"
                  alt="Success"
                  width="100"
                />
              </Grid>
              <Grid
                item
                md={12}
                style={{ display: "flex", justifyContent: "center" }}
              >
                <h3 style={{ color: "red" }}>{alertMsg}</h3>
              </Grid>
            </Grid>
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: "flex", justifyContent: "center" }}>
          <Button
            onClick={handleAddClose41}
            variant="contained"
            color="color"
            style={{
              backgroundColor: companyTheme?.primaryColorCode,
              color: "white",
              borderRadius: "4px",
            }}
          >
            Ok
          </Button>
        </DialogActions>
      </Dialog>
      <div className={classes.newDesignRoot}>
        <div
          className={classes.formHead}
        >

          <div
            style={{
              flexGrow: 1,
            }}
          >
            <Grid container spacing={0}>
              <Grid item xs={12} md={12}>
                <ExtraForm
                  guest={guest}
                  pickUp={pickup}
                  modelCat={modelCat}
                  setModelCat={setModelCat}
                />
              </Grid>
              {/* <Grid item xs={12} md={6}>
                
              </Grid> */}
            </Grid>
          </div>
          <>
            <BookButton
              defaultPassengerId={defaultPassengerId}
              selectedModel={selectedModel}
              driverDetails={driverDetails}
              dateValue={dateValue}
              pickUp={pickup}
              drop={drop}
              setsearchingDriver={setsearchingDriver}
              setshowErrorMessage={setshowErrorMessage}
              setTripID={setTripID}
              setBookType={setBookType}
              bookType={bookType}
              setTransferStatus={setTransferStatus}
              fullDayStatus={fullDayStatus}
              transferStatus={transferStatus}
              halfDayStatus={halfDayStatus}
              // roundTripStatus={roundTripStatus}
              setFullDayStatus={setFullDayStatus}
              setHalfDayStatus={setHalfDayStatus}
              setApproxTripFare={setApproxTripFare}
              subscriptionStatus={subscriptionStatus}
              setSubscriptionStatus={setSubscriptionStatus}
              hourlyStatus={hourlyStatus}
              setHourlyStatus={setHourlyStatus}
              activeIndex={activeIndex}
              fareDetails={fareDetails}
              // setRoundTripStatus={setRoundTripStatus}
              error={error}
              setError={setError}
              guest={guest}
              approxTripFare={approxTripFare}
              distance={distance}
              duration={duration}
              planBaseFare={planBaseFare}
              setPlanBaseFare={setPlanBaseFare}
              selectedDays={selectedDays}
              selectedHourlyTime={selectedHourlyTime}
              subscriptionTripFare={subscriptionTripFare}
              setTotalDaysCount={setTotalDaysCount}
              setPickupTimeSlot={setPickupTimeSlot}
              setDropTimeSlot={setDropTimeSlot}
              pickUp1={pickup1}
              drop1={drop1}
              twoWayBaseFare={twoWayBaseFare}
              setTwoWayBaseFare={setTwoWayBaseFare}
              twoWayTripFare={twoWayTripFare}
              setTwoWayTripFare={setTwoWayTripFare}
              selectedHourlyBookingTime={selectedHourlyBookingTime}
              recurringBookingEnable={recurringBookingEnable}
              companyId={companyId}
              companyTheme={companyTheme}
              modelHourlyFare={modelHourlyFare}
              isValidPlan={isValidPlan}
              oneWayRoutePolyline={oneWayRoutePolyline}
              twoWayRoutePolyline={twoWayRoutePolyline}
              errMsg={errMsg}
              dropErrMsg={dropErrMsg}
              setPickupErrMsg={setPickupErrMsg}
            />



            {bookType === 3 ? (
              <SubscriptionPlanPicker
                selectedPlan={selectedPlan}
                subscriptionPlan={subscriptionPlan}
                activeIndexSub={activeIndexSub}
                setActiveIndexSub={setActiveIndexSub}
                fareDetails1={fareDetails1}

              />
            ) : null}

            <AddressSearchBar />


            {bookType === 4 && pickup.coords.lat() !== 0 && drop.coords.lat() !== 0 ? (
              <Box style={{ flexGrow: 1, marginTop: "20px" }}>
                <Grid
                  container
                  spacing={1}
                  flexDirection="row"
                  alignItems="center"
                >
                  <Grid item xs={4}>
                    <Typography style={{ fontSize: "14px", fontWeight: "400" }}>
                      Hours
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <FormControl style={{ width: "100%" }}>
                      {/* <InputLabel shrink={true}>Select Hours</InputLabel> */}
                      <Select
                        value={selectedHourlyBookingTime || ""}
                        onChange={(e) => {
                          // console.log("duration", duration);
                          setSelectedHourlyBookingTime(e.target.value);
                        }}
                        // input={<OutlinedInput label="Select Hours" />}
                        input={<OutlinedInput />}
                      >
                        {/* {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]?.map((num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      ))} */}
                        {[1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12].map((num) => {
                          const durationInHours = Math.ceil(duration / 60);
                          const shouldDisable = duration < 60 ? false : num <= durationInHours;

                          return (
                            <MenuItem
                              key={num}
                              value={num}
                              disabled={shouldDisable}
                            >
                              {num}
                            </MenuItem>
                          );
                        })}

                        {/* {Array.from(
                        { length: selectedPlan?.hours || 0 },
                        (_, i) => i + 1
                      ).map((num) => (
                        <MenuItem key={num} value={num}>
                          {num}
                        </MenuItem>
                      ))} */}
                      </Select>
                    </FormControl>
                  </Grid>
                </Grid>
              </Box>
            ) : null}

            {bookType === 3 ? (
              <SchedulePicker
                startDate={startDate}
                setStartDate={setStartDate}
                endDate={endDate}
                setEndDate={setEndDate}
                time={time}
                setTime={setTime}
                selectedModel={selectedModel}
                baseFare={planBaseFare}
                setBaseFare={setPlanBaseFare}
                path={path}
                pickUp={pickup}
                drop={drop}
                isHourlyPlan={isHourlyPlan}
                setIsHourlyPlan={setIsHourlyPlan}
                selectedDays={selectedDays}
                setSelectedDays={setSelectedDays}
                selectedPlan={selectedPlan}
                selectedHourlyTime={selectedHourlyTime}
                setSelectedHourlyTime={setSelectedHourlyTime}
                subscriptionTripFare={subscriptionTripFare}
                setSubscriptionTripFare={setSubscriptionTripFare}
                twoWayPickupTime={twoWayPickupTime}
                setTwoWayPickupTime={setTwoWayPickupTime}
                totalDaysCount={totalDaysCount}
                setTotalDaysCount={setTotalDaysCount}
                setPickupTimeSlot={setPickupTimeSlot}
                setDropTimeSlot={setDropTimeSlot}
                path1={path1}
                pickUp1={pickup1}
                drop1={drop1}
                twoWayBaseFare={twoWayBaseFare}
                setTwoWayBaseFare={setTwoWayBaseFare}
                twoWayTripFare={twoWayTripFare}
                setTwoWayTripFare={setTwoWayTripFare}
                setDayTimeState={setDayTimeState}
                dayTimeState={dayTimeState}
                isRecurringBooking={isRecurringBooking}
                setIsRecurringBooking={setIsRecurringBooking}
                recurringBookingEnable={recurringBookingEnable}
                setRecurringBookingEnable={setRecurringBookingEnable}
              />
            ) : (
              <SchedulePickerOld />
            )}

            <BookButtonNew
              defaultPassengerId={defaultPassengerId}
              selectedModel={selectedModel}
              driverDetails={driverDetails}
              dateValue={dateValue}
              selectedPlan={selectedPlan}
              pickUp={pickup}
              drop={drop}
              setsearchingDriver={setsearchingDriver}
              setshowErrorMessage={setshowErrorMessage}
              setTripID={setTripID}
              setBookType={setBookType}
              bookType={bookType}
              setTransferStatus={setTransferStatus}
              fullDayStatus={fullDayStatus}
              transferStatus={transferStatus}
              halfDayStatus={halfDayStatus}
              setFullDayStatus={setFullDayStatus}
              setHalfDayStatus={setHalfDayStatus}
              setApproxTripFare={setApproxTripFare}
              subscriptionStatus={subscriptionStatus}
              setSubscriptionStatus={setSubscriptionStatus}
              hourlyStatus={hourlyStatus}
              setHourlyStatus={setHourlyStatus}
              activeIndex={activeIndex}
              fareDetails={fareDetails}
              error={error}
              setError={setError}
              guest={guest}
              approxTripFare={approxTripFare}
              startDate={startDate}
              endDate={endDate}
              time={time}
              setStartDate={setStartDate}
              setEndDate={setEndDate}
              setTime={setTime}
              setPickup={setPickup}
              setDrop={setDrop}
              planBaseFare={planBaseFare}
              setPlanBaseFare={setPlanBaseFare}
              selectedDays={selectedDays}
              selectedHourlyTime={selectedHourlyTime}
              subscriptionTripFare={subscriptionTripFare}
              twoWayPickupTime={twoWayPickupTime}
              distance={distance}
              duration={duration}
              waypoints={waypoints}
              pickUp1={pickup1}
              drop1={drop1}
              twoWaypoints={twoWaypoints}
              twoWayBaseFare={twoWayBaseFare}
              twoWayTripFare={twoWayTripFare}
              selectedHourlyBookingTime={selectedHourlyBookingTime}
              recurringBookingEnable={recurringBookingEnable}
              fareDetails1={fareDetails1}
              companyId={companyId}
              companyTheme={companyTheme}
              modelHourlyFare={modelHourlyFare}
              distance2={distance2}
              duration2={duration2}
              totalDaysCount={totalDaysCount}
              isValidPlan={isValidPlan}
              oneWayRoutePolyline={oneWayRoutePolyline}
              twoWayRoutePolyline={twoWayRoutePolyline}
              errMsg={errMsg}
              dropErrMsg={dropErrMsg}
              setPickupErrMsg={setPickupErrMsg}
            />
          </>
          {/* ) : (
            ""
          )} */}

          {/*<Message />*/}
          {/* <DetailPage /> */}
          {/* <ConfirmedDriver /> */}
          {/* <WaitingForDriver /> */}
        </div>
      </div>
    </>
  );
}
